"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44121],{

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 763962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DiscountColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DiscountColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "8", fill: "#F6FFED" }
      },
      {
        tag: "path",
        attr: {
          d: "M16.6667 6.66687H7.33333C6.4496 6.66793 5.60237 7.01946 4.97748 7.64435C4.35259 8.26924 4.00106 9.11647 4 10.0002V14.0002C4.00106 14.8839 4.35259 15.7312 4.97748 16.3561C5.60237 16.9809 6.4496 17.3325 7.33333 17.3335H16.6667C17.5504 17.3325 18.3976 16.9809 19.0225 16.3561C19.6474 15.7312 19.9989 14.8839 20 14.0002V10.0002C19.9989 9.11647 19.6474 8.26924 19.0225 7.64435C18.3976 7.01946 17.5504 6.66793 16.6667 6.66687ZM6.66667 15.3335C6.53481 15.3335 6.40592 15.2944 6.29629 15.2212C6.18665 15.1479 6.10121 15.0438 6.05075 14.922C6.00029 14.8002 5.98709 14.6661 6.01281 14.5368C6.03853 14.4075 6.10203 14.2887 6.19526 14.1955C6.2885 14.1022 6.40729 14.0387 6.53661 14.013C6.66593 13.9873 6.79997 14.0005 6.92179 14.051C7.04361 14.1014 7.14773 14.1869 7.22098 14.2965C7.29423 14.4061 7.33333 14.535 7.33333 14.6669C7.33333 14.8437 7.2631 15.0133 7.13807 15.1383C7.01305 15.2633 6.84348 15.3335 6.66667 15.3335ZM6.66667 10.0002C6.53481 10.0002 6.40592 9.9611 6.29629 9.88785C6.18665 9.8146 6.10121 9.71048 6.05075 9.58866C6.00029 9.46684 5.98709 9.3328 6.01281 9.20348C6.03853 9.07416 6.10203 8.95537 6.19526 8.86213C6.2885 8.7689 6.40729 8.7054 6.53661 8.67968C6.66593 8.65396 6.79997 8.66716 6.92179 8.71762C7.04361 8.76808 7.14773 8.85352 7.22098 8.96316C7.29423 9.07279 7.33333 9.20168 7.33333 9.33354C7.33333 9.51035 7.2631 9.67992 7.13807 9.80494C7.01305 9.92997 6.84348 10.0002 6.66667 10.0002ZM12 14.6669C11.4726 14.6669 10.957 14.5105 10.5185 14.2175C10.0799 13.9244 9.73815 13.508 9.53632 13.0207C9.33449 12.5334 9.28168 11.9972 9.38457 11.48C9.48747 10.9627 9.74144 10.4875 10.1144 10.1146C10.4873 9.74165 10.9625 9.48767 11.4798 9.38478C11.997 9.28188 12.5332 9.33469 13.0205 9.53652C13.5078 9.73836 13.9242 10.0802 14.2173 10.5187C14.5103 10.9572 14.6667 11.4728 14.6667 12.0002C14.6667 12.7074 14.3857 13.3857 13.8856 13.8858C13.3855 14.3859 12.7072 14.6669 12 14.6669ZM17.3333 15.3335C17.2015 15.3335 17.0726 15.2944 16.963 15.2212C16.8533 15.1479 16.7679 15.0438 16.7174 14.922C16.667 14.8002 16.6538 14.6661 16.6795 14.5368C16.7052 14.4075 16.7687 14.2887 16.8619 14.1955C16.9552 14.1022 17.074 14.0387 17.2033 14.013C17.3326 13.9873 17.4666 14.0005 17.5885 14.051C17.7103 14.1014 17.8144 14.1869 17.8876 14.2965C17.9609 14.4061 18 14.535 18 14.6669C18 14.8437 17.9298 15.0133 17.8047 15.1383C17.6797 15.2633 17.5101 15.3335 17.3333 15.3335ZM17.3333 10.0002C17.2015 10.0002 17.0726 9.9611 16.963 9.88785C16.8533 9.8146 16.7679 9.71048 16.7174 9.58866C16.667 9.46684 16.6538 9.3328 16.6795 9.20348C16.7052 9.07416 16.7687 8.95537 16.8619 8.86213C16.9552 8.7689 17.074 8.7054 17.2033 8.67968C17.3326 8.65396 17.4666 8.66716 17.5885 8.71762C17.7103 8.76808 17.8144 8.85352 17.8876 8.96316C17.9609 9.07279 18 9.20168 18 9.33354C18 9.51035 17.9298 9.67992 17.8047 9.80494C17.6797 9.92997 17.5101 10.0002 17.3333 10.0002ZM13.3333 12.0002C13.3333 12.2639 13.2551 12.5217 13.1086 12.741C12.9621 12.9602 12.7539 13.1311 12.5102 13.232C12.2666 13.333 11.9985 13.3594 11.7399 13.3079C11.4812 13.2565 11.2437 13.1295 11.0572 12.943C10.8707 12.7565 10.7437 12.519 10.6923 12.2603C10.6408 12.0017 10.6672 11.7336 10.7682 11.49C10.8691 11.2463 11.04 11.0381 11.2592 10.8916C11.4785 10.7451 11.7363 10.6669 12 10.6669C12.3536 10.6669 12.6928 10.8073 12.9428 11.0574C13.1929 11.3074 13.3333 11.6466 13.3333 12.0002Z",
          fill: "#52C41A"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 178504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FacebookFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FacebookFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M22 12.0599C21.9998 10.1489 21.452 8.27796 20.4215 6.66861C19.391 5.05926 17.921 3.77888 16.1854 2.97905C14.4498 2.17922 12.5214 1.89344 10.6285 2.15554C8.73552 2.41764 6.95732 3.21665 5.50437 4.45796C4.05142 5.69928 2.98457 7.33092 2.43013 9.15973C1.87569 10.9885 1.85687 12.9379 2.37591 14.7771C2.89494 16.6162 3.93009 18.2682 5.35881 19.5373C6.78752 20.8064 8.54997 21.6396 10.4375 21.9382V14.9507H7.89833V12.0599H10.4375V9.85655C10.4375 7.35072 11.9308 5.96572 14.2142 5.96572C14.9643 5.97648 15.7126 6.04165 16.4533 6.16072V8.62238H15.1917C14.8119 8.57197 14.4276 8.67445 14.1233 8.90729C13.8191 9.14013 13.6197 9.48427 13.5692 9.86405C13.5549 9.9704 13.5526 10.078 13.5625 10.1849V12.0599H16.3333L15.89 14.9507H13.5567V21.9382C15.91 21.5674 18.0537 20.3685 19.6016 18.5575C21.1495 16.7465 22.0001 14.4423 22 12.0599Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "20",
                  height: "20",
                  fill: "white",
                  transform: "translate(2 2)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 576862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FlashSaleFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FlashSaleFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.27655 5.41169C9.37245 4.86779 9.89111 4.50462 10.435 4.60053L16.5319 5.67558C16.898 5.74012 17.0681 6.16732 16.8467 6.46585L13.3551 11.1733C13.2222 11.3524 13.3243 11.6087 13.544 11.6475L15.36 11.9677C15.74 12.0347 15.9041 12.4887 15.6548 12.7832L9.75245 19.7537C9.55456 19.9874 9.17488 19.8093 9.22806 19.5077L10.1988 14.0023C10.2468 13.7304 10.0652 13.4711 9.79323 13.4231L8.9069 13.2668C8.363 13.1709 7.99984 12.6523 8.09574 12.1084L9.27655 5.41169Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 188543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const LinkOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M10.3333 12.8332C10.7936 12.8332 11.1667 12.4601 11.1667 11.9999C11.1667 10.6216 12.2883 9.49991 13.6666 9.49991H17.8333C19.2116 9.49991 20.3333 10.6216 20.3333 11.9999C20.3333 13.3782 19.2116 14.4999 17.8333 14.4999L16.3333 14.5C15.8731 14.5 15.5 14.8731 15.5 15.3333C15.5 15.7935 15.8731 16.1665 16.3333 16.1665H17.8333C20.1308 16.1665 21.9999 14.2974 21.9999 11.9999C21.9999 9.70241 20.1308 7.83325 17.8333 7.83325H13.6666C11.3692 7.83325 9.5 9.70241 9.5 11.9999C9.5 12.4601 9.87311 12.8332 10.3333 12.8332Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.6667 11.1665C13.2075 11.1665 12.8333 11.5 12.8333 11.9999C12.8333 13.3782 11.7117 14.4998 10.3334 14.4998L6.16671 14.4998C4.78839 14.4998 3.66672 13.3782 3.66672 11.9999C3.66672 10.6215 4.78838 9.49987 6.16671 9.49987L7.66667 9.49987C8.12691 9.49987 8.5 9.12678 8.5 8.66654C8.5 8.20631 8.12691 7.83321 7.66667 7.83321L6.16671 7.83321C3.86922 7.83321 2.00007 9.70237 2.00007 11.9999C2.00007 14.2973 3.86922 16.1665 6.16671 16.1665L10.3334 16.1665C12.6308 16.1665 14.5 14.2973 14.5 11.9999C14.5 11.5396 14.1269 11.1665 13.6667 11.1665Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 876856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MessengerColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MessengerColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "-149.1 -248.49675 1292.2 1490.9805" },
    child: [
      {
        tag: "g",
        attr: { transform: "translate(-15 -11.5)" },
        child: [
          {
            tag: "linearGradient",
            attr: {
              y2: "1005.5",
              x2: "512",
              y1: "11.5",
              x1: "512",
              gradientUnits: "userSpaceOnUse",
              id: "a"
            },
            child: [
              { tag: "stop", attr: { offset: "0", stopColor: "#00b2ff" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#006aff" } }
            ]
          },
          {
            tag: "path",
            attr: {
              d: "M512 11.5c-280 0-497 205.1-497 482.1 0 144.9 59.4 270.1 156.1 356.6 8.1 7.3 13 17.4 13.4 28.3l2.7 88.4c.9 28.2 30 46.5 55.8 35.2l98.6-43.5c8.4-3.7 17.7-4.4 26.5-2 45.3 12.5 93.6 19.1 143.9 19.1 280 0 497-205.1 497-482.1S792 11.5 512 11.5z",
              fill: "url(#a)",
              fillRule: "evenodd",
              clipRule: "evenodd"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M213.6 634.6l146-231.6c23.2-36.8 73-46 107.8-19.9l116.1 87.1c10.7 8 25.3 7.9 35.9-.1l156.8-119c20.9-15.9 48.3 9.2 34.2 31.4L664.5 614c-23.2 36.8-73 46-107.8 19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9.1L247.8 666c-20.9 15.9-48.3-9.2-34.2-31.4z",
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#fff"
            }
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 624485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ VoucherTagColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VoucherTagColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
          fill: "#FFF1F0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8 20H9.42C9.71836 19.9972 10.0073 19.8953 10.2415 19.7105C10.4757 19.5256 10.6419 19.2682 10.714 18.9787C10.7912 18.6968 10.9588 18.4481 11.1912 18.2708C11.4236 18.0935 11.7077 17.9974 12 17.9974C12.2923 17.9974 12.5764 18.0935 12.8088 18.2708C13.0412 18.4481 13.2088 18.6968 13.286 18.9787C13.3581 19.2682 13.5243 19.5256 13.7585 19.7105C13.9927 19.8953 14.2816 19.9972 14.58 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V15.3333H15.3333C15.1565 15.3333 14.987 15.2631 14.8619 15.1381C14.7369 15.013 14.6667 14.8435 14.6667 14.6667C14.6667 14.4899 14.7369 14.3203 14.8619 14.1953C14.987 14.0702 15.1565 14 15.3333 14H18V7.33333C17.9989 6.4496 17.6474 5.60237 17.0225 4.97748C16.3976 4.35259 15.5504 4.00106 14.6667 4L14.58 4C14.2816 4.00283 13.9927 4.10468 13.7585 4.28953C13.5243 4.47439 13.3581 4.7318 13.286 5.02133C13.2088 5.30323 13.0412 5.55195 12.8088 5.72924C12.5764 5.90652 12.2923 6.00256 12 6.00256C11.7077 6.00256 11.4236 5.90652 11.1912 5.72924C10.9588 5.55195 10.7912 5.30323 10.714 5.02133C10.6419 4.7318 10.4757 4.47439 10.2415 4.28953C10.0073 4.10468 9.71836 4.00283 9.42 4H9.33333C8.4496 4.00106 7.60237 4.35259 6.97748 4.97748C6.35259 5.60237 6.00106 6.4496 6 7.33333V14H8.66667C8.84348 14 9.01305 14.0702 9.13807 14.1953C9.2631 14.3203 9.33333 14.4899 9.33333 14.6667C9.33333 14.8435 9.2631 15.013 9.13807 15.1381C9.01305 15.2631 8.84348 15.3333 8.66667 15.3333H6V18C6 18.5304 6.21071 19.0391 6.58579 19.4142C6.96086 19.7893 7.46957 20 8 20ZM11.3333 14H12.6667C12.8435 14 13.013 14.0702 13.1381 14.1953C13.2631 14.3203 13.3333 14.4899 13.3333 14.6667C13.3333 14.8435 13.2631 15.013 13.1381 15.1381C13.013 15.2631 12.8435 15.3333 12.6667 15.3333H11.3333C11.1565 15.3333 10.987 15.2631 10.8619 15.1381C10.7369 15.013 10.6667 14.8435 10.6667 14.6667C10.6667 14.4899 10.7369 14.3203 10.8619 14.1953C10.987 14.0702 11.1565 14 11.3333 14Z",
          fill: "#F5222D"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 14766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FacebookComment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(724656);




const FacebookComment = ({
  href,
  numPosts,
  width,
  appId,
  language,
  colorScheme,
  mobile,
  lazy
}) => {
  const { available, fb, xfbmlParse } = (0,_useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useFacebookSDK */ .c)(appId, language);
  const [xfbmlRender, setRender] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!fb || !available)
      return;
    setRender(false);
    if (ref.current) {
      ref.current.style.height = "1px";
    }
    xfbmlParse();
    fb.Event.subscribe("xfbml.render", () => {
      setRender(true);
      if (ref.current) {
        ref.current.style.height = "auto";
      }
    });
    return () => {
      fb.Event.unsubscribe("xfbml.render", () => {
        setRender(false);
      });
    };
  }, [fb, href, numPosts, available]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, available ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !xfbmlRender && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FacebookCommentSkeleton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fb-comments",
    "data-href": href,
    "data-numposts": numPosts,
    "data-width": width,
    "data-lazy": lazy,
    "data-mobile": mobile,
    "data-colorscheme": colorScheme
  }))) : null);
};
FacebookComment.displayName = "FacebookComment";
FacebookComment.defaultProps = {
  width: "100%",
  numPosts: 5,
  colorScheme: "light",
  mobile: "auto-detect",
  lazy: true
};
const FacebookCommentSkeleton = () => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "0.5rem",
    marginBottom: "s36",
    padding: ["s8", "s0"]
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: 1,
    marginBottom: "s24"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "4rem",
    width: "100%",
    marginBottom: "s16"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  overflow: hidden;
`;




/***/ }),

/***/ 724656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useFacebookSDK; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [available, setAvailable] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _a;
    if (typeof window === "undefined")
      return;
    if (typeof FB != "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=v16.0&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};




/***/ }),

/***/ 192719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RelateVideosAndPosts": function() { return /* binding */ RelateVideosAndPosts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(517293);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  line-height: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 540px;\n  background-color: black;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const YoutubeFrame = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 42609).then(__webpack_require__.bind(__webpack_require__, 742609)).then((mod)=>mod.YoutubeFrame), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(742609)
            ]
    }
});
const MAX_ITEMS_WITH_TWO_BLOCKS = 3;
const StyledH3 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].h3(_templateObject());
const IFramePopupWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject1());
const StyledCustomLink = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x)(_templateObject2());
const RelatedBlock = (props)=>{
    const { 0: youtubeLink , 1: setYoutubeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const { title , type , seeMoreUrl , items  } = props;
    const renderItem = (url, description)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
            gap: "s8",
            align: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .LazyImage */ .w, {
                    height: "56px",
                    width: "100px",
                    borderRadius: 6,
                    contain: true,
                    src: url,
                    imageWidth: 200
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                    width: "calc(100% - 100px - 16px)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                        line: 3,
                        level: 1,
                        children: description
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                padding: "s16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledH3, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                        gap: "s12",
                        direction: "column",
                        marginTop: "s12",
                        children: items.map((item, index)=>{
                            const { url , thumbnailUrl , description  } = item;
                            return type === "post" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCustomLink, {
                                href: url,
                                target: "_blank",
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                                onClick: ()=>setYoutubeLink(url),
                                style: {
                                    cursor: "pointer",
                                    width: "100%"
                                },
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url));
                        })
                    }),
                    !!seeMoreUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
                        href: seeMoreUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                            paddingTop: "s16",
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                                variant: "link",
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Xem th\xeam nội dung"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .ChevronForwardFilled */ .O, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Modal */ .u, {
                visible: !!youtubeLink,
                width: "960px",
                onClose: ()=>setYoutubeLink(""),
                showCloseIcon: false,
                footer: false,
                contentStyle: {
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IFramePopupWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeFrame, {
                        youtubeLink: youtubeLink
                    })
                })
            })
        ]
    });
};
const RelateVideosAndPosts = (props)=>{
    var ref, ref1, ref2, ref3;
    const { relatedPosts , relatedVideos  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref = relatedVideos.urls) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: relatedVideos.urls.map((video, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "VideoObject",
                                name: video.name,
                                description: video.description,
                                thumbnailUrl: video.thumbnailUrl,
                                uploadDate: typeof video.uploadDate === "number" ? new Date(video.uploadDate * 1000).toISOString() : "",
                                embedUrl: video.url
                            })
                        }
                    }, "".concat(index).concat(video.url));
                })
            }),
            !!(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref1 = relatedPosts.urls) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                marginTop: "s12",
                marginBottom: !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref2 = relatedVideos.urls) === null || ref2 === void 0 ? void 0 : ref2.length) ? "s0" : "s12",
                backgroundColor: "white",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedPosts.title || "",
                    type: "post",
                    seeMoreUrl: relatedPosts.seeMoreUrl,
                    items: relatedPosts.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , description  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: description || ""
                        };
                    })
                })
            }),
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref3 = relatedVideos.urls) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                margin: [
                    "s12",
                    "s0"
                ],
                backgroundColor: "white",
                border: "s8",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedVideos.title || "",
                    type: "video",
                    seeMoreUrl: relatedVideos.seeMoreUrl,
                    items: relatedVideos.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , name  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: name || ""
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 751817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RecentViewedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(743126);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(309396);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(679376);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88837);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(185081);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const RecentViewedProducts = (props)=>{
    const { render , excludedSkus  } = props, rest = _objectWithoutProperties(props, [
        "render",
        "excludedSkus"
    ]);
    const recentViewedProductsSkus = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)() ? (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__/* .RECENTLY_VIEWED_PRODUCTS_KEY */ ._V) || "[]", []) || [] : [];
    const { result , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSearch */ .Rx)(recentViewedProductsSkus.length ? {
        filter: {
            skus: recentViewedProductsSkus,
            excludedSkus: excludedSkus
        },
        pageSize: 50,
        page: 1
    } : {});
    const products = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const newProducts = [];
        recentViewedProductsSkus.forEach((sku)=>{
            const productFoundBySku = result.products.find((item)=>item.sku === sku);
            if (productFoundBySku) {
                newProducts.push(productFoundBySku);
            }
        });
        return newProducts;
    }, [
        result.products
    ]);
    if (!products.length && !isLoading) return null;
    return !!render ? render(products) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, _objectSpreadProps(_objectSpread({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .ProductCarouselWithHeader */ .B, {
                header: {
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm vừa xem")
                },
                products: products,
                regionName: "viewedItem"
            })
        })
    }));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .CommonStyles */ .F, "\n    background: white;\n    border-radius: 0.5rem;\n    margin-bottom: 1.5rem;\n    .product-card{\n      border: 1px solid ".concat(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .themeColor.divider */ .E.divider, ";\n      border-radius: 4px;\n    }\n  "));


/***/ }),

/***/ 76877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useIntersectionObserver; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* globals IntersectionObserverInit */ 
function useIntersectionObserver(options) {
    const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const { 0: isVisible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setVisible(entry.isIntersecting);
        }, options);
        const node = elementRef.current;
        if (node) {
            observer.observe(node);
        }
        return ()=>{
            observer.disconnect();
        };
    }, [
        options
    ]);
    return [
        elementRef,
        isVisible
    ];
}


/***/ }),

/***/ 606174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DetailPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(560327);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(955006);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(329944);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(431529);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(488924);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(493460);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(842918);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(414562);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(14766);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77322);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(184019);
/* harmony import */ var components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(110413);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(243290);
/* harmony import */ var components_RelatedVideosAndPosts__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(192719);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(288257);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(185081);
/* harmony import */ var constants_smartBanner__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(124177);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(723357);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(684443);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(391547);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(504133);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(788813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(353632);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(770353);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var modules_product_detail_shared_ReviewSection__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(555082);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(891987);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(504545);
/* harmony import */ var _shared_MetaData__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(812388);
/* harmony import */ var _ShareButtons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(439764);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 50%;\n  left: 8px;\n  right: auto;\n  z-index: 1030;\n  cursor: pointer;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  transform: translateY(-50%);\n  background-color: rgba(168, 168, 168, 0.46);\n  border-top-right-radius: 100px;\n  border-bottom-right-radius: 100px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























const Policies = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 96537).then(__webpack_require__.bind(__webpack_require__, 796537)).then((mod)=>mod.Policies), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(796537)
            ]
    }
});
const ProductRelatedPromotions = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 63505).then(__webpack_require__.bind(__webpack_require__, 463505)).then((mod)=>mod.ProductRelatedPromotions), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(463505)
            ]
    }
});
const ProductCombo = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(24077), __webpack_require__.e(75329), __webpack_require__.e(50343), __webpack_require__.e(67777), __webpack_require__.e(43983), __webpack_require__.e(19317)]).then(__webpack_require__.bind(__webpack_require__, 243983)).then((mod)=>mod.ProductCombo), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(243983)
            ]
    }
});
const ProductHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 70771).then(__webpack_require__.bind(__webpack_require__, 170771)).then((mod)=>mod.ProductHeader), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(170771)
            ]
    }
});
const ActionButtons = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 19947).then(__webpack_require__.bind(__webpack_require__, 619947)).then((mod)=>mod.ActionButtons), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(619947)
            ]
    }
});
const ProductImages = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 52348).then(__webpack_require__.bind(__webpack_require__, 552348)).then((mod)=>mod.ProductImages), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(552348)
            ]
    }
});
const ProductVariants = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 78097).then(__webpack_require__.bind(__webpack_require__, 762782)).then((mod)=>mod.ProductVariants), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(762782)
            ]
    }
});
const PriceAtLocationPicker = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 77123).then(__webpack_require__.bind(__webpack_require__, 177123)).then((mod)=>mod.PriceAtLocationPicker), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(177123)
            ]
    }
});
const ProductSpecifications = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 47417).then(__webpack_require__.bind(__webpack_require__, 847417)).then((mod)=>mod.ProductSpecifications), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(847417)
            ]
    }
});
const Description = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 143).then(__webpack_require__.bind(__webpack_require__, 100143)).then((mod)=>mod.ProductDescription), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(100143)
            ]
    }
});
const ProductPriceAndPromotion = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 45605).then(__webpack_require__.bind(__webpack_require__, 945605)).then((mod)=>mod.ProductPriceAndPromotion), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(945605)
            ]
    }
});
const ConfirmOver18YearOldModal = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(76698), __webpack_require__.e(23540), __webpack_require__.e(83822)]).then(__webpack_require__.bind(__webpack_require__, 923540)).then((mod)=>mod.ConfirmOver18YearOldModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(923540)
            ]
    }
});
const FAQSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5854).then(__webpack_require__.bind(__webpack_require__, 565458)).then((mod)=>mod.FAQSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(565458)
            ]
    }
});
const NewReviewSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 669878)).then((mod)=>mod.ReviewSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(669878)
            ]
    }
});
const renderFlashSaleBadge = (total, sold, stock, endAt)=>{
    const remain = Math.min(total - sold, stock);
    const message = sold / total > 0.9 || remain < 5 ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sắp ch\xe1y h\xe0ng") : (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("C\xf2n lại {{remain}}", {
        remain: remain
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .FlashSaleBar */ .P, {
        endAt: new Date(endAt),
        text: message,
        margin: [
            "s16",
            "s0"
        ],
        padding: "s8"
    });
};
const DetailPage = (param)=>{
    let { showRelatedPromotion =true , extraPromotions =[]  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlags */ .g)();
    const specificationRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const { product , stockAvailable , showFlashSale , primitiveProduct , relatedProducts , showPopupCheckAge , setShowPopupCheckAge , breadcrumbs , inlineBanners ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_11__/* .useProductDetailState */ .W)();
    const { allowCommentAndReceiveReply , currentLanguage , addSchemaBreadcrumbList , baseDomain , showDetailPageGoBackArrow , epicOmni1550 ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_12__/* .useTenantConfig */ .Wx)();
    const { asPath , back  } = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const flashSaleBadge = showFlashSale && (product === null || product === void 0 ? void 0 : product.flashSale) && stockAvailable ? renderFlashSaleBadge(product.flashSale.total, product.flashSale.used, stockAvailable, product.flashSale.endAt) : null;
    (0,hooks__WEBPACK_IMPORTED_MODULE_13__/* .useIdentifiedPage */ .w)("productDetail");
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (product) {
            var ref, ref1, ref2, ref3;
            (0,helpers__WEBPACK_IMPORTED_MODULE_14__/* .saveRecentlyProduct */ .l3)(product.sku, constants_index__WEBPACK_IMPORTED_MODULE_15__/* .RECENTLY_VIEWED_PRODUCTS_KEY */ ._V);
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_16__/* .trackViewProductDetail */ .g)({
                price: (ref = product.price) === null || ref === void 0 ? void 0 : ref.price,
                name: product.name,
                sku: product.sku,
                brand: (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name,
                category: ((ref2 = product.categories) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name) || "",
                sellerSku: product === null || product === void 0 ? void 0 : product.sellerSku
            });
        }
    }, [
        product === null || product === void 0 ? void 0 : product.sku
    ]);
    const scrollToSpecification = ()=>{
        var ref;
        (ref = specificationRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    if (!product) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .NotFoundProductLayout */ .DH, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_18__/* .NoProductsFound */ .H, {
                show: true,
                text: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Kh\xf4ng t\xecm thấy sản phẩm")
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!addSchemaBreadcrumbList && !!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            itemListElement: breadcrumbs.map((param, index)=>{
                                let { name , link , isLast  } = param;
                                return {
                                    "@type": "ListItem",
                                    position: index + 1,
                                    item: {
                                        name: !index ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Trang chủ") : name,
                                        "@id": link === "#" || !!isLast ? "".concat(baseDomain).concat(asPath) : "".concat(baseDomain).concat(link)
                                    }
                                };
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_MetaData__WEBPACK_IMPORTED_MODULE_19__/* .MetaData */ .U, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Wrapper */ .im, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Breadcrumbs */ .O, {
                            breadcrumbs: breadcrumbs || []
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                            marginBottom: 24,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    width: "75.6%",
                                    marginRight: 16,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Card */ .Zb, {
                                        style: {
                                            padding: "24px",
                                            height: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                                    width: "40.5%",
                                                    paddingRight: 16,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImages, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Divider */ .i, {
                                                            dividerStyle: _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.dashed */ .fd.dashed,
                                                            margin: [
                                                                "s12",
                                                                "s0"
                                                            ],
                                                            color: "divider"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Content */ .VY, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: (dompurify__WEBPACK_IMPORTED_MODULE_2___default()) === null || (dompurify__WEBPACK_IMPORTED_MODULE_2___default()) === void 0 ? void 0 : (ref1 = (dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize)) === null || ref1 === void 0 ? void 0 : ref1.call((dompurify__WEBPACK_IMPORTED_MODULE_2___default()), (product === null || product === void 0 ? void 0 : (ref = product.seoInfo) === null || ref === void 0 ? void 0 : ref.shortDescription) || "")
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__/* .Button */ .z, {
                                                            variant: "link",
                                                            onClick: scrollToSpecification,
                                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Xem th\xf4ng tin chi tiết")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShareButtons__WEBPACK_IMPORTED_MODULE_24__/* .ShareButtons */ .n, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                                                    marginTop: 12,
                                                                    marginLeft: 12,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__/* .Body */ .uT, {
                                                                            level: 1,
                                                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Y\xeau th\xedch ")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_26__/* .WishlistButton */ .s, {
                                                                            sku: product.sku
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                                    width: "59.5%",
                                                    children: [
                                                        flashSaleBadge,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductHeader, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .ProductVariantsWrapper */ .W, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductVariants, {})
                                                        }),
                                                        (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceAtLocationPicker, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductPriceAndPromotion, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionButtons, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_27__/* .BannerInlinePlaceholder */ .Q, {
                                                            banners: inlineBanners,
                                                            className: constants_smartBanner__WEBPACK_IMPORTED_MODULE_28__/* .INLINE_BANNER_CLASSNAME.INLINE_PDP_RELATEDPROMO */ .h.INLINE_PDP_RELATEDPROMO
                                                        }),
                                                        showRelatedPromotion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductRelatedPromotions, {
                                                            extraPromotions: extraPromotions
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "productAfterPromoBox"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    width: "24.4%",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Policies, {
                                            wrapperProps: {
                                                itemVerticalSpacing: "s16"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_27__/* .BannerInlinePlaceholder */ .Q, {
                                            banners: inlineBanners,
                                            className: constants_smartBanner__WEBPACK_IMPORTED_MODULE_28__/* .INLINE_BANNER_CLASSNAME.INLINE_PDP_SERVICE */ .h.INLINE_PDP_SERVICE
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                            marginBottom: 24,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                width: "75.6%",
                                marginRight: 16,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCombo, {})
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__/* .LazyComponent */ .c, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__/* .Flex */ .k, {
                                    marginBottom: "s24",
                                    gap: "s16",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .DescriptionCol */ .Ag, {
                                            height: "100%",
                                            width: "calc((100% - 16px)/3 * 2)",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__/* .Col */ .JX, {
                                            ref: specificationRef,
                                            width: "calc((100% - 16px)/3)",
                                            height: "100%",
                                            style: {
                                                scrollMarginTop: "137px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductSpecifications, {}),
                                                (!!((ref2 = product.seoInfo) === null || ref2 === void 0 ? void 0 : ref2.relatedVideos) || !!((ref3 = product.seoInfo) === null || ref3 === void 0 ? void 0 : ref3.relatedPosts)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedVideosAndPosts__WEBPACK_IMPORTED_MODULE_32__.RelateVideosAndPosts, {
                                                    relatedVideos: (ref4 = product.seoInfo) === null || ref4 === void 0 ? void 0 : ref4.relatedVideos,
                                                    relatedPosts: (ref5 = product.seoInfo) === null || ref5 === void 0 ? void 0 : ref5.relatedPosts
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                epicOmni1550 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewReviewSection, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_product_detail_shared_ReviewSection__WEBPACK_IMPORTED_MODULE_33__.ReviewSection, {
                                    product: product
                                })
                            ]
                        }),
                        !!((ref6 = product.seoInfo) === null || ref6 === void 0 ? void 0 : ref6.faq) && product.seoInfo.faq.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQSection, {
                            faq: ((ref7 = product.seoInfo) === null || ref7 === void 0 ? void 0 : ref7.faq) || [],
                            style: {
                                padding: "0px",
                                width: "100%"
                            }
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__/* .LazyComponent */ .c, {
                            children: relatedProducts.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Card */ .Zb, {
                                style: {
                                    marginBottom: "24px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_34__/* .BlockHeader */ .t, {
                                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm li\xean quan")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_35__/* .ProductCarousel */ .G, {
                                            products: relatedProducts,
                                            productsPerRow: 5,
                                            regionName: "relatedProducts",
                                            virtual: (0,helpers__WEBPACK_IMPORTED_MODULE_36__/* .isServerless */ .ep)()
                                        })
                                    ]
                                })
                            }) : null
                        }),
                        allowCommentAndReceiveReply && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__/* .LazyComponent */ .c, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCommentWrapper, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_37__/* .FacebookComment */ .F, {
                                    appId: (0,helpers__WEBPACK_IMPORTED_MODULE_38__/* .getEnv */ .dU)("NEXT_PUBLIC_FACEBOOK_APP_ID"),
                                    language: currentLanguage,
                                    href: "".concat((0,helpers__WEBPACK_IMPORTED_MODULE_14__/* .getBaseDomain */ .xq)(), "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref8 = primitiveProduct.productInfo) === null || ref8 === void 0 ? void 0 : ref8.canonical)
                                })
                            })
                        })
                    ]
                })
            }),
            showPopupCheckAge !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfirmOver18YearOldModal, {
                showPopupCheckAge: showPopupCheckAge,
                setShowPopupCheckAge: setShowPopupCheckAge
            }),
            !!showDetailPageGoBackArrow && (0,helpers__WEBPACK_IMPORTED_MODULE_36__/* .isServerless */ .ep)() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_39__/* .BackOutlined */ .Y, {
                    size: 30,
                    color: "#333",
                    onClick: ()=>{
                        back();
                    }
                })
            })
        ]
    });
};
const ProductCommentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_40__["default"].div(_templateObject());
const IconWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_40__["default"].div(_templateObject1());


/***/ }),

/***/ 915935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ProductDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(640793);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(891256);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(517844);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(684443);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(391547);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  min-height: 632px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  &:nth-of-type(even) {\n    background-color: #f6f6f6;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  > * {\n    max-width: 800px;\n  }\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  max-height: 85vh;\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey;\n    border-radius: 10px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #cccccc;\n    border-radius: 10px;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #c8c5c5;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 24px;\n  border: 1px solid\n    ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  line-height: 1.5rem;\n  padding: 16px 0px;\n  h2 {\n    font-size: 20px;\n    line-height: 1.4;\n  }\n  h3 {\n    font-size: 16px;\n    line-height: 1.3;\n  }\n  h4 {\n    font-size: 14px;\n  }\n  h5 {\n    font-size: 12px;\n  }\n  h6 {\n    font-size: 10px;\n  }\n  img {\n    height: auto;\n  }\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  .tab-item {\n    padding: 16px;\n  }\n  .tab-item > div:is([type='body'], [type='subtitle']) {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







const Drawer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 27165).then(__webpack_require__.bind(__webpack_require__, 427165)).then((mod)=>mod.Drawer), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(427165)
            ]
    }
});
const ProductDescription = (props)=>{
    var ref, ref1, ref2, ref3;
    const { buttonType ="link" , tabTitle =[
        (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Th\xf4ng tin sản phẩm"),
        (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("M\xf4 tả chi tiết")
    ] ,  } = props;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useProductDetailState */ .W)();
    const { epicOmni1643  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const displayAttributes = (ref = product === null || product === void 0 ? void 0 : product.attributeGroups) === null || ref === void 0 ? void 0 : ref.filter((att)=>!!att.value && att.parentId !== 0);
    const { 0: isShowMoreAttributes , 1: setShowMoreAttributes  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const description = product === null || product === void 0 ? void 0 : (ref1 = product.seoInfo) === null || ref1 === void 0 ? void 0 : ref1.description;
    const { 0: showMoreDescriptionNeeded , 1: setShowMoreDescriptionNeeded  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const { 0: isExpanded , 1: setExpanded  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const MAX_PRODUCT_DESCRIPTION_HEIGHT = epicOmni1643 ? 632 : 503;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(WrapperProductDescription, {
        id: "desktop-product-description",
        backgroundColor: "white",
        borderRadius: "xl",
        padding: [
            "s0",
            "s16"
        ],
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledTabs, {
                defaultTab: 0,
                type: "line",
                textActiveColor: "textTitle",
                textColor: "textPrimary",
                tabTitleProps: {
                    style: {
                        padding: "s16"
                    }
                },
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .TabItem */ .E, {
                        minWidth: "50%",
                        className: "tab-item",
                        text: tabTitle[0],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpecificationsWrapper, {
                            children: !!(displayAttributes === null || displayAttributes === void 0 ? void 0 : displayAttributes.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Specifications, {
                                        attributes: displayAttributes.slice(0, 8)
                                    }),
                                    !!(displayAttributes === null || displayAttributes === void 0 ? void 0 : displayAttributes.length) && displayAttributes.length > 8 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                        variant: buttonType,
                                        onClick: ()=>setShowMoreAttributes(true),
                                        margin: "s16",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Xem th\xeam")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                                height: MAX_PRODUCT_DESCRIPTION_HEIGHT,
                                backgroundColor: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .TabItem */ .E, {
                        minWidth: "50%",
                        className: "tab-item",
                        text: tabTitle[1],
                        children: !!description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Content, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                                    style: showMoreDescriptionNeeded ? {
                                        overflow: "hidden",
                                        transition: "height 0.3s ease",
                                        height: isExpanded ? (ref2 = contentRef.current) === null || ref2 === void 0 ? void 0 : ref2.clientHeight : "".concat(MAX_PRODUCT_DESCRIPTION_HEIGHT, "px")
                                    } : {},
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDescription, {
                                        className: "ck-content",
                                        ref: (e)=>{
                                            !!e && !showMoreDescriptionNeeded && setShowMoreDescriptionNeeded(e.clientHeight > MAX_PRODUCT_DESCRIPTION_HEIGHT);
                                            contentRef.current = e;
                                        },
                                        isExpanded: isExpanded,
                                        dangerouslySetInnerHTML: {
                                            __html: (dompurify__WEBPACK_IMPORTED_MODULE_1___default()) === null || (dompurify__WEBPACK_IMPORTED_MODULE_1___default()) === void 0 ? void 0 : (ref3 = (dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize)) === null || ref3 === void 0 ? void 0 : ref3.call((dompurify__WEBPACK_IMPORTED_MODULE_1___default()), description, {
                                                ADD_TAGS: [
                                                    "iframe"
                                                ]
                                            })
                                        },
                                        showMoreNeeded: showMoreDescriptionNeeded
                                    })
                                }),
                                showMoreDescriptionNeeded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .k, {
                                    justify: "center",
                                    padding: "s12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                        variant: buttonType,
                                        onClick: ()=>setExpanded((previous)=>!previous),
                                        children: isExpanded ? (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Thu gọn") : (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Xem th\xeam")
                                    })
                                }) : null
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                            height: MAX_PRODUCT_DESCRIPTION_HEIGHT,
                            backgroundColor: "white"
                        })
                    })
                ]
            }),
            !epicOmni1643 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u, {
                show: isShowMoreAttributes,
                onHide: ()=>setShowMoreAttributes(false),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .ModalHeader */ .x, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Th\xf4ng tin sản phẩm")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledModalBody, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Specifications, {
                            attributes: displayAttributes
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Drawer, {
                open: isShowMoreAttributes,
                onClose: ()=>setShowMoreAttributes(false),
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Th\xf4ng tin sản phẩm"),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Specifications, {
                    attributes: displayAttributes
                })
            })
        ]
    });
};
const WrapperProductDescription = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(_templateObject());
const Specifications = (param)=>{
    let { attributes  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
        width: "100%",
        children: attributes.map((att, index)=>{
            var ref;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AttributeWrapper, {
                direction: "row",
                padding: [
                    "s12",
                    "s16"
                ],
                gap: "s8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                        level: 1,
                        color: "textSecondary",
                        style: {
                            flex: 2
                        },
                        children: att.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                        level: 1,
                        color: "textPrimary",
                        dangerouslySetInnerHTML: {
                            __html: (dompurify__WEBPACK_IMPORTED_MODULE_1___default()) === null || (dompurify__WEBPACK_IMPORTED_MODULE_1___default()) === void 0 ? void 0 : (ref = (dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize)) === null || ref === void 0 ? void 0 : ref.call((dompurify__WEBPACK_IMPORTED_MODULE_1___default()), att.value, {
                                ADD_TAGS: [
                                    "iframe"
                                ]
                            })
                        },
                        style: {
                            flex: 3
                        }
                    })
                ]
            }, "".concat(index).concat(att.name));
        })
    });
};
const AttributeWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .k)(_templateObject1());
const SpecificationsWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .k)(_templateObject2());
const StyledModalBody = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__/* .ModalBody */ .f)(_templateObject3());
const StyledDescription = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div((param)=>{
    let { isExpanded , showMoreNeeded  } = param;
    return "\n  overflow: hidden;\n  * {\n    max-width: 100%;\n  }\n    \n  .table table {\n    table-layout: auto;\n  }\n  ul,\n  ul li {\n    list-style-type: inherit;\n  }\n\n  ul {\n    /* Default user agent stylesheet. */\n    padding-left: 40px;\n  }\n\n  ol,\n  ol li {\n    list-style-type: decimal;\n  }\n  ol {\n    /* Default user agent stylesheet, you can change it to your needs. */\n    padding-left: 40px;\n  }\n  ".concat(!isExpanded && showMoreNeeded ? "\n  &:after {\n    content: ' ';\n    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);\n    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));\n    position: absolute;\n    left: 0;\n    bottom: 56px;\n    height: 40px;\n    width: 100%;\n  };\n  padding-bottom: 14px;\n  " : "", "\n");
});
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .Button */ .z)(_templateObject4(), (param)=>{
    let { theme , variant  } = param;
    return variant === "ghost" ? theme.colors.border : "transparent";
});
const Content = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div(_templateObject5());
const StyledTabs = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Tabs */ .m)(_templateObject6());


/***/ }),

/***/ 439764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ ShareButtons; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/MessengerColored.es.js
var MessengerColored_es = __webpack_require__(876856);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FacebookFilled.es.js
var FacebookFilled_es = __webpack_require__(178504);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LinkOutlined.es.js
var LinkOutlined_es = __webpack_require__(188543);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./assets/zalo-logo.svg
var zalo_logo = __webpack_require__(434883);
;// CONCATENATED MODULE: ./components/desktop/organisms/ZaloShareButton.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(",
        ");\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




const ZaloShareButton = (param)=>{
    let { url , size ="26" , zaloOAId ,  } = param;
    (0,react.useEffect)(()=>{
        // Gọi reload để init lại widget nếu cần
        if ( true && window.ZaloSocialSDK) {
            window.ZaloSocialSDK.reload();
        }
    }, [
        url
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledZaloIcon, {
        className: "zalo-share-button",
        "data-href": url,
        "data-oaid": zaloOAId,
        "data-customize": true,
        size: size
    });
};
const StyledZaloIcon = emotion_styled_browser_esm["default"].div(_templateObject(), (prop)=>prop.size, (prop)=>prop.size, zalo_logo/* default */.Z);

// EXTERNAL MODULE: ./contexts/ToastContext.tsx
var ToastContext = __webpack_require__(508285);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/ShareButtons.tsx
function ShareButtons_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ShareButtons_templateObject() {
    const data = ShareButtons_taggedTemplateLiteral([
        "\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n  cursor: pointer;\n"
    ]);
    ShareButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = ShareButtons_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  background-color: #52c41a;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








const ShareButtons = ()=>{
    const toast = (0,ToastContext/* useToast */.p)();
    const { getProcessEnv , zaloOAId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const router = (0,next_router.useRouter)();
    const { 0: zaloShareUrl , 1: setzaloShareUrl  } = (0,react.useState)("");
    const copyCurrentUrl = async ()=>{
        var ref, ref1;
        if (typeof navigator === "undefined" || "object" === "undefined" || !navigator || !((ref = window.location) === null || ref === void 0 ? void 0 : ref.href)) {
            return;
        }
        await navigator.clipboard.writeText(window.location.href);
        (ref1 = toast.success) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
            title: null,
            message: (0,i18n.t)("Đ\xe3 sao ch\xe9p đường dẫn")
        });
    };
    const shareFacebook = ()=>{
        var ref;
        if ( false || !((ref = window.location) === null || ref === void 0 ? void 0 : ref.href)) return;
        window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(window.location.href)), "new-window", "status = 1, width=".concat(window.screen.width / 2, ", height=").concat(window.screen.height / 2, ", top=").concat(window.screen.height / 4, ", \n      left=").concat(window.screen.width / 4, ", scrollbars=no"));
    };
    const shareMessenger = ()=>{
        var ref;
        if ( false || !((ref = window.location) === null || ref === void 0 ? void 0 : ref.href)) return;
        window.open("http://www.facebook.com/dialog/send?app_id=".concat(getProcessEnv("NEXT_PUBLIC_FB_APP_ID"), "&link=").concat(encodeURIComponent(window.location.href), "&redirect_uri=").concat(encodeURIComponent(window.location.href)), "new-window", "status = 1, width=".concat(window.screen.width / 2, ", height=").concat(window.screen.height / 2, ", top=").concat(window.screen.height / 4, ", \n      left=").concat(window.screen.width / 4, ", scrollbars=no"));
    };
    //set zaloShareUrl
    (0,react.useEffect)(()=>{
        if (true) {
            const fullUrl = window.location.origin + router.asPath;
            setzaloShareUrl(fullUrl);
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
        gap: "s8",
        marginTop: "s12",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                level: 1,
                children: [
                    (0,i18n.t)("Chia sẻ"),
                    ": "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                gap: "s4",
                align: "center",
                justify: "center",
                children: [
                    !!zaloShareUrl && !!zaloOAId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "24px",
                        width: "24px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZaloShareButton, {
                            url: zaloShareUrl,
                            zaloOAId: zaloOAId,
                            size: "18"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerColored_es/* MessengerColored */.q, {
                        onClick: shareMessenger,
                        size: "24",
                        style: {
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "24px",
                        width: "24px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookFilled_es/* FacebookFilled */.J, {
                            onClick: shareFacebook,
                            size: "20",
                            style: {
                                cursor: "pointer"
                            },
                            color: "#0958D9"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "24px",
                        width: "24px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOutlinedWrapper, {
                            height: "16px",
                            width: "16px",
                            onClick: copyCurrentUrl,
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkOutlined, {
                                color: "white",
                                size: "14"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const StyledLinkOutlined = (0,emotion_styled_browser_esm["default"])(LinkOutlined_es/* LinkOutlined */.Z)(ShareButtons_templateObject());
const LinkOutlinedWrapper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject1());


/***/ }),

/***/ 483531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ DetailPageSGC; },
  "d": function() { return /* binding */ MAX_WIDTH; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tekface-smart-activation-virtual-e73eef34fa/0/cache/@tekface-smart-activation-npm-1.0.10-2939c41d04-992c9a64f7.zip/node_modules/@tekface/smart-activation/dist/components/InlineBannerPlaceholder.es.js
var InlineBannerPlaceholder_es = __webpack_require__(560327);
// EXTERNAL MODULE: ../../packages/cart/dist/v2/index.js
var v2 = __webpack_require__(511335);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NoProductsFound/NoProductsFound.es.js + 1 modules
var NoProductsFound_es = __webpack_require__(493460);
// EXTERNAL MODULE: ../../packages/tracking/dist/product.es.js
var product_es = __webpack_require__(77322);
// EXTERNAL MODULE: ./components/ProductDetail/styles.ts
var styles = __webpack_require__(243290);
// EXTERNAL MODULE: ./components/WishlistButton.tsx
var WishlistButton = __webpack_require__(288257);
// EXTERNAL MODULE: ./components/desktop/organisms/RecentViewedProducts.tsx
var RecentViewedProducts = __webpack_require__(751817);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./constants/smartBanner.ts
var smartBanner = __webpack_require__(124177);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./hooks/useIntersectionObserver.ts
var useIntersectionObserver = __webpack_require__(76877);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/product-detail/shared/DefaultPromotions.tsx + 1 modules
var DefaultPromotions = __webpack_require__(693442);
// EXTERNAL MODULE: ./modules/product-detail/shared/FlashSalePromotionBlock.tsx + 3 modules
var FlashSalePromotionBlock = __webpack_require__(981282);
// EXTERNAL MODULE: ./modules/product-detail/shared/PaymentPromotion.tsx
var PaymentPromotion = __webpack_require__(575771);
// EXTERNAL MODULE: ./modules/product-detail/shared/Policies.tsx
var Policies = __webpack_require__(542826);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductInfo.tsx
var ProductInfo = __webpack_require__(326557);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductNews/index.tsx + 4 modules
var ProductNews = __webpack_require__(825047);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductProviderInfo.tsx
var ProductProviderInfo = __webpack_require__(768439);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductReview/ReviewSection.tsx + 11 modules
var ReviewSection = __webpack_require__(669878);
// EXTERNAL MODULE: ./modules/product-detail/shared/ReviewSection.tsx
var shared_ReviewSection = __webpack_require__(555082);
// EXTERNAL MODULE: ./modules/product-detail/shared/TierPromotion.tsx + 1 modules
var TierPromotion = __webpack_require__(795021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/head.js
var head = __webpack_require__(979894);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-62ae8f912b/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(504545);
// EXTERNAL MODULE: ./modules/product-detail/shared/MetaData.tsx
var MetaData = __webpack_require__(812388);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductUnitAndPrice.tsx + 1 modules
var ProductUnitAndPrice = __webpack_require__(857260);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/NewProductDescription.tsx
var NewProductDescription = __webpack_require__(915935);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/ShareButtons.tsx + 1 modules
var ShareButtons = __webpack_require__(439764);
// EXTERNAL MODULE: ../../packages/cart/dist/v2/utils.es.js
var utils_es = __webpack_require__(916476);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Toast/hooks.es.js
var hooks_es = __webpack_require__(314408);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CautionOutlined.es.js
var CautionOutlined_es = __webpack_require__(47649);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/tracking/dist/interface.es.js
var interface_es = __webpack_require__(141873);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(446586);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ActionButtons.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  white-space: nowrap;\n  border-radius: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  border-radius: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const ActionButtons = (param)=>{
    let { actionButtonsRef  } = param;
    var ref;
    const router = (0,next_router.useRouter)();
    const { contactLink , allowBuyNow  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { product , price , isOutOfStock , actionReady , payloadAddToCart , isCanAddToCard , stockAvailable , primitiveProduct , selectedPromotion ,  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const showToast = (0,hooks_es/* useToast */.p)();
    const { onAddSingleItem  } = (0,CartContextV2/* useCartV2 */.T6)();
    const isValidPrice = (0,react.useMemo)(()=>{
        if (!product) return false;
        if (price) return (price === null || price === void 0 ? void 0 : price.finalPrice) && (price === null || price === void 0 ? void 0 : price.finalPrice) >= 0;
    }, [
        product,
        price
    ]);
    const showContact = !isValidPrice || isOutOfStock || !(product === null || product === void 0 ? void 0 : (ref = product.status) === null || ref === void 0 ? void 0 : ref.sellable);
    const trackingPayload = JSON.stringify({
        sku: product === null || product === void 0 ? void 0 : product.sellerSku,
        screenName: "productDetail"
    });
    const onAddItemToCart = async (type)=>{
        var ref, ref1;
        if (!isCanAddToCard) {
            var ref2;
            (ref2 = showToast.info) === null || ref2 === void 0 ? void 0 : ref2.call(showToast, {
                title: "",
                message: (0,i18n.t)("Chỉ c\xf2n {{stockAvailable}} sản phẩm", {
                    stockAvailable
                }),
                type: "error",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CautionOutlined_es/* CautionOutlined */.s, {
                    size: 50,
                    color: "#E24C4B"
                })
            });
            return;
        }
        if (!primitiveProduct) return;
        // params send to Teko tracking in event addToCart
        const trackAddToCartParams = {
            product: {
                sku: (product === null || product === void 0 ? void 0 : product.sellerSku) || "",
                name: (product === null || product === void 0 ? void 0 : product.name) || "",
                brand: product === null || product === void 0 ? void 0 : product.brand,
                categories: product === null || product === void 0 ? void 0 : product.categories,
                price: parseFloat((product === null || product === void 0 ? void 0 : (ref = product.price) === null || ref === void 0 ? void 0 : (ref1 = ref.supplierRetailPrice) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "0"),
                addToCartPrice: (price === null || price === void 0 ? void 0 : price.finalPrice) || 0,
                sellerSku: product === null || product === void 0 ? void 0 : product.sellerSku
            },
            selectedPromotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
            type
        };
        try {
            if (!(payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku)) return;
            const res = await onAddSingleItem({
                sku: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku,
                promotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
                quantity: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity,
                isPrimary: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.isPrimary
            }, false, allowBuyNow && type === interface_es/* AddToCartType.BUYNOW */.h.BUYNOW ? utils_es/* IsolatedCartType.BUY_NOW */.oG.BUY_NOW : undefined);
            if (res) {
                (0,cart_es/* trackAddToCart */.Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "success",
                    cartId: res.id
                }));
            } else {
                (0,cart_es/* trackAddToCart */.Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "failed"
                }));
            }
            if (res && (type === interface_es/* AddToCartType.BUYNOW */.h.BUYNOW || type === interface_es/* AddToCartType.INSTALLMENT */.h.INSTALLMENT)) {
                if (type === interface_es/* AddToCartType.BUYNOW */.h.BUYNOW && !allowBuyNow) {
                    router.push("/cart");
                } else {
                    const key = (0,utils_es/* getBuyNowKey */.B2)(true);
                    router.push("/checkout?bnk=".concat(key));
                }
            }
        } catch (e) {
            (0,cart_es/* trackAddToCart */.Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                status: "failed"
            }));
            dist_index_es/* logger.error */.k.error(e);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: actionButtonsRef,
        children: [
            !showContact && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                style: {
                    gap: "8px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                        isTrackContent: true,
                        contentName: "addToCart",
                        target: "productDetail",
                        regionName: "descriptionDetail",
                        payload: trackingPayload
                    })), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            variant: "secondary",
                            onClick: ()=>onAddItemToCart(interface_es/* AddToCartType.ADDTOCART */.h.ADDTOCART),
                            block: true,
                            disabled: !actionReady,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                            })
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowButton, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                        isTrackContent: true,
                        contentName: "buyNow",
                        regionName: "descriptionDetail",
                        target: "cart",
                        payload: trackingPayload
                    })), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            variant: "primary",
                            block: true,
                            disabled: !actionReady,
                            onClick: ()=>onAddItemToCart(interface_es/* AddToCartType.BUYNOW */.h.BUYNOW),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n.t)("Mua ngay")
                            })
                        })
                    }))
                ]
            }),
            showContact && !!contactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                href: contactLink,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                    isTrackContent: true,
                    regionName: "descriptionDetail",
                    contentName: "contactSale",
                    target: "productDetail",
                    payload: trackingPayload
                })), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        variant: "primary",
                        block: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                            level: 2,
                            weight: "medium",
                            children: (0,i18n.t)("Li\xean hệ")
                        })
                    })
                }))
            }),
            showContact && !contactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                disabled: true,
                block: true,
                style: {
                    backgroundColor: "#0000000A",
                    border: "1px solid #00000026"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                    level: 2,
                    weight: "medium",
                    color: "#00000040",
                    children: (0,i18n.t)("Hết h\xe0ng")
                })
            })
        ]
    });
};
const AddToCartButton = emotion_styled_browser_esm["default"].div(_templateObject());
const BuyNowButton = emotion_styled_browser_esm["default"].div(_templateObject1());
const StyledButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)((param)=>{
    let { height  } = param;
    return "\n  height: ".concat(height || "56px", ";\n  border-radius: 16px;\n");
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/BottomActionBar/BottomActionBar.es.js
var BottomActionBar_es = __webpack_require__(174925);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(353632);
// EXTERNAL MODULE: ./modules/product-detail/hooks/useBottomButtons.tsx
var useBottomButtons = __webpack_require__(119198);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/BottomButtons.tsx
function BottomButtons_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BottomButtons_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BottomButtons_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BottomButtons_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function BottomButtons_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        BottomButtons_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function BottomButtons_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BottomButtons_templateObject() {
    const data = BottomButtons_taggedTemplateLiteral([
        "\n  position: sticky;\n  display: block;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  box-shadow: 0 -5px 10px -3px rgba(0, 0, 0, 0.2);\n"
    ]);
    BottomButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BottomButtons_templateObject1() {
    const data = BottomButtons_taggedTemplateLiteral([
        "\n  padding-left: 8%;\n  padding-right: 8%;\n"
    ]);
    BottomButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = BottomButtons_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = BottomButtons_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n  .quantity-text {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    margin-right: 8px;\n    white-space: nowrap;\n  }\n  .quantity-selector {\n    width: 132px !important;\n    height: 36px !important;\n    .rc-input-number-input {\n      border-left: 1px solid #e4e5f0;\n      border-right: 1px solid #e4e5f0;\n      background-color: white;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = BottomButtons_taggedTemplateLiteral([
        "\n  padding-left: 16px;\n  padding-right: 16px;\n  display: flex;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










const BottomButtons = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { colors  } = (0,Theme_es/* useTheme */.F)();
    const { contactLink , allowBuyNow , uomCodeToDisplayDecimalQuantity  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { onBuy , onBuyNow  } = (0,useBottomButtons/* useBottomButtons */.D)();
    const { product , price , isOutOfStock , actionReady , payloadAddToCart , setPayloadAddToCart ,  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { loading: cartLoading  } = (0,CartContextV2/* useCartV2 */.T6)();
    const isValidPrice = (0,react.useMemo)(()=>{
        if (!product) return false;
        if (price) return price.finalPrice >= 0;
    }, [
        product,
        price
    ]);
    const showContact = !isValidPrice || isOutOfStock || !(product === null || product === void 0 ? void 0 : (ref = product.status) === null || ref === void 0 ? void 0 : ref.sellable);
    const precision = (product === null || product === void 0 ? void 0 : product.uomCode) === uomCodeToDisplayDecimalQuantity ? 3 : 0;
    const selectedVariants = (0,react.useMemo)(()=>{
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.productOptions) === null || ref === void 0 ? void 0 : ref.rows.map((variant)=>variant.options.filter((option)=>option.selected).map((option)=>option.label)).join(", ");
    }, [
        product === null || product === void 0 ? void 0 : (ref1 = product.productOptions) === null || ref1 === void 0 ? void 0 : ref1.rows
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomActionBar, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
            maxWidth: MAX_WIDTH,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                style: {
                    alignItems: "center"
                },
                justify: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "start",
                        width: "50%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                style: {
                                    minWidth: 0,
                                    width: "60%"
                                },
                                wrap: false,
                                align: "middle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        style: {
                                            minWidth: 48
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                                            width: 48,
                                            height: 48,
                                            src: (product === null || product === void 0 ? void 0 : (ref2 = product.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.src) || "",
                                            alt: product === null || product === void 0 ? void 0 : (ref4 = product.images) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.alt
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                                        style: {
                                            padding: "0 8px",
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisText, {
                                                style: {
                                                    fontWeight: "bold",
                                                    fontSize: "15px"
                                                },
                                                children: product === null || product === void 0 ? void 0 : product.displayName
                                            }),
                                            !!(product === null || product === void 0 ? void 0 : (ref6 = product.productOptions) === null || ref6 === void 0 ? void 0 : ref6.rows.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EllipsisText, {
                                                style: {
                                                    color: colors.textSecondary
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            (0,i18n.t)("Ph\xe2n loại"),
                                                            ": "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: selectedVariants
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityBlock, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, BottomButtons_objectSpreadProps(BottomButtons_objectSpread({
                                    className: "quantity-selector",
                                    disableMinus: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) === 1,
                                    quantity: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1,
                                    setQuantity: (value)=>{
                                        if (value !== (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity)) {
                                            setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                                                return BottomButtons_objectSpreadProps(BottomButtons_objectSpread({}, prev), {
                                                    quantity: value
                                                });
                                            });
                                        }
                                    },
                                    onPlus: ()=>{
                                        setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                                            return BottomButtons_objectSpreadProps(BottomButtons_objectSpread({}, prev), {
                                                quantity: (prev.quantity || 1) + 1
                                            });
                                        });
                                    },
                                    onMinus: ()=>{
                                        if (((payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1) - 1 > 0) {
                                            setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                                                return BottomButtons_objectSpreadProps(BottomButtons_objectSpread({}, prev), {
                                                    quantity: (prev.quantity || 1) - 1
                                                });
                                            });
                                        }
                                    },
                                    min: Math.pow(10, -precision)
                                }, (0,env/* getEnv */.dU)("EPIC_ECOM_489") !== "enabled" ? {
                                    decimalSeparator: "."
                                } : {}), {
                                    precision: precision,
                                    blurOnEnter: true
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        style: {
                            alignItems: "center"
                        },
                        justify: "end",
                        width: "50%",
                        children: showContact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                            width: "100%",
                            padding: [
                                "s0",
                                "s16"
                            ],
                            children: !!contactLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, BottomButtons_objectSpreadProps(BottomButtons_objectSpread({
                                variant: "primary",
                                width: "100%",
                                disabled: !actionReady,
                                borderRadius: "m",
                                onClick: ()=>{
                                    if (contactLink) window.open(contactLink);
                                    return;
                                },
                                style: !actionReady ? {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    border: "1px solid rgba(0, 0, 0, 0.15)",
                                    color: "rgba(0, 0, 0, 0.25)"
                                } : {}
                            }, (0,helper_es/* getTrackingData */.O5)({
                                isTrackContent: true,
                                contentName: "contactSale",
                                target: "productDetail",
                                regionName: "bottomProductDetail",
                                payload: JSON.stringify({
                                    sku: product === null || product === void 0 ? void 0 : product.sku,
                                    screenName: "productDetail"
                                })
                            })), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                    level: 2,
                                    children: (0,i18n.t)("Li\xean hệ")
                                })
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                disabled: true,
                                block: true,
                                style: {
                                    backgroundColor: "#0000000A",
                                    border: "1px solid #00000026"
                                },
                                borderRadius: "m",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                    level: 2,
                                    weight: "medium",
                                    color: "#00000040",
                                    children: (0,i18n.t)("Hết h\xe0ng")
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(PurchaseButtons, {
                            style: {
                                maxWidth: allowBuyNow ? "fit-content" : "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, BottomButtons_objectSpreadProps(BottomButtons_objectSpread({
                                    width: "100%"
                                }, (0,helper_es/* getTrackingData */.O5)({
                                    isTrackContent: true,
                                    contentName: "addToCart",
                                    target: "productDetail",
                                    regionName: "bottomProductDetail",
                                    payload: JSON.stringify({
                                        sku: product.sku,
                                        screenName: "productDetail"
                                    })
                                })), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                        width: allowBuyNow ? "180px" : "100%",
                                        variant: allowBuyNow ? "secondary" : "primary",
                                        disabled: !actionReady || cartLoading,
                                        borderRadius: "m",
                                        onClick: onBuy,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                            level: 2,
                                            style: {
                                                whiteSpace: "nowrap"
                                            },
                                            children: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                                        })
                                    })
                                })),
                                allowBuyNow && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, BottomButtons_objectSpreadProps(BottomButtons_objectSpread({
                                    width: "100%"
                                }, (0,helper_es/* getTrackingData */.O5)({
                                    isTrackContent: true,
                                    contentName: "buyNow",
                                    target: "productDetail",
                                    regionName: "bottomProductDetail",
                                    payload: JSON.stringify({
                                        sku: product.sku,
                                        screenName: "productDetail"
                                    })
                                })), {
                                    style: {
                                        display: "flex",
                                        justifyContent: "flex-end"
                                    },
                                    marginLeft: "s16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                        width: "180px",
                                        variant: "primary",
                                        disabled: !actionReady || cartLoading,
                                        borderRadius: "m",
                                        onClick: onBuyNow,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                            level: 2,
                                            children: (0,i18n.t)("Mua ngay")
                                        })
                                    })
                                }))
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const StyledBottomActionBar = (0,emotion_styled_browser_esm["default"])(BottomActionBar_es/* BottomActionBar */.G)(BottomButtons_templateObject());
const StyledContent = (0,emotion_styled_browser_esm["default"])(Container_es/* Container */.W)(BottomButtons_templateObject1());
const EllipsisText = emotion_styled_browser_esm["default"].div(_templateObject2());
const QuantityBlock = emotion_styled_browser_esm["default"].div(_templateObject3());
const PurchaseButtons = emotion_styled_browser_esm["default"].div(_templateObject4());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/CustomRecentProductCarousel.tsx
function CustomRecentProductCarousel_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CustomRecentProductCarousel_templateObject() {
    const data = CustomRecentProductCarousel_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: white;\n  padding: 16px;\n  border-radius: 16px;\n"
    ]);
    CustomRecentProductCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const CustomRecentProductCarousel = (param)=>{
    let { recentProducts  } = param;
    if (!recentProducts.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Title */.Dx, {
                children: (0,i18n.t)("Sản phẩm vừa xem")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_es/* ProductCarousel */.G, {
                products: recentProducts,
                productsPerRow: 6.5,
                regionName: "viewedItem",
                virtual: (0,helpers/* isServerless */.ep)(),
                customStyleLeftArrow: arrowStyle,
                customStyleRightArrow: arrowStyle,
                desktopProps: {
                    perSwipe: "",
                    bound: true
                }
            })
        ]
    });
};
const arrowStyle = {
    backgroundColor: "white",
    borderRadius: 999,
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 15px"
};
const Wrapper = emotion_styled_browser_esm["default"].div(CustomRecentProductCarousel_templateObject());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js
var Overlay_es = __webpack_require__(92300);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/YoutubeIframe/YoutubeIframe.es.js
var YoutubeIframe_es = __webpack_require__(55930);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Glide/Glide.es.js + 1 modules
var Glide_es = __webpack_require__(349416);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/constants/index.es.js
var constants_index_es = __webpack_require__(875547);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SmallImage/SmallImages.es.js
var SmallImages_es = __webpack_require__(732324);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductVideo/ProductVideo.es.js
var ProductVideo_es = __webpack_require__(7297);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Gallery/Gallery.es.js
var Gallery_es = __webpack_require__(888393);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductImageZoom.tsx
var ProductImageZoom = __webpack_require__(893202);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductImages.tsx
function ProductImages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductImages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductImages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductImages_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ProductImages_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ProductImages_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ProductImages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductImages_templateObject() {
    const data = ProductImages_taggedTemplateLiteral([
        "\n  aspect-ratio: 1;\n"
    ]);
    ProductImages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductImages_templateObject1() {
    const data = ProductImages_taggedTemplateLiteral([
        "\n  .horizontal-slider,\n  .glide__track {\n    max-width: calc(100% - 56px - 4rem);\n  }\n"
    ]);
    ProductImages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







const ProductImages = ()=>{
    const { product , frame  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { 0: showGallery , 1: setShowGallery  } = (0,react.useState)(false);
    const { 0: activeIndex , 1: setActiveIndex  } = (0,react.useState)(0);
    const vidRef = (0,react.useRef)(null);
    const images = (product === null || product === void 0 ? void 0 : product.images) || [];
    const videos = (product === null || product === void 0 ? void 0 : product.videos) || [];
    const displayItems = [
        ...videos,
        ...images
    ];
    const renderDisplayItems = ()=>{
        return displayItems.map((img, index)=>{
            if (index < videos.length) {
                if (img.source === constants_index_es/* SOURCE_VIDEO.SYSTEM */.Ok.SYSTEM) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemFrame, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailVideo, {
                            url: img.url,
                            source: img.source,
                            isActive: index === activeIndex,
                            videoProps: {
                                ref: vidRef,
                                width: "100%",
                                height: "100%",
                                preload: "none",
                                playsInline: true,
                                autoPlay: true,
                                muted: true,
                                onClick: ()=>setActiveIndex(index),
                                onPlayingCapture: ()=>{
                                    var ref;
                                    return (ref = vidRef.current) === null || ref === void 0 ? void 0 : ref.pause();
                                }
                            }
                        }, index)
                    }, index);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemFrame, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledYoutubeThumbnail, {
                        width: "100%",
                        height: "100%",
                        isActive: index === activeIndex,
                        youtubeLink: img.url,
                        onClick: ()=>{
                            setActiveIndex(index);
                        }
                    }, index)
                }, index);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemFrame, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallImages_es/* SmallImage */.K, {
                    width: "100%",
                    height: "100%",
                    borderRadius: 8,
                    borderColor: "#dddddd",
                    image: img,
                    alt: img.alt,
                    isActive: index === activeIndex,
                    borderWidth: index === activeIndex ? 1.5 : 1,
                    onClick: ()=>{
                        setActiveIndex(index);
                    }
                }, index)
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", ProductImages_objectSpreadProps(ProductImages_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "imgProductDetail",
        contentName: "viewImage",
        target: "productImage",
        payload: JSON.stringify({
            sku: product === null || product === void 0 ? void 0 : product.sellerSku,
            screenName: "productDetail",
            index: activeIndex
        })
    })), {
        style: {
            marginBottom: 16,
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative",
                    marginBottom: "0.5rem",
                    width: "100%"
                },
                children: [
                    frame && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameWrapper, {
                        frame: frame
                    }),
                    images || videos ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: activeIndex < videos.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo_es/* ProductVideo */.N, {
                                source: videos[activeIndex].source,
                                videoProps: {
                                    preload: "none",
                                    width: "100%",
                                    height: 560,
                                    playsInline: true,
                                    muted: true,
                                    autoPlay: true,
                                    controls: true,
                                    src: videos[activeIndex].url,
                                    onClick: ()=>setShowGallery(true)
                                },
                                youtubeFrameProps: {
                                    width: "100%",
                                    height: 560,
                                    autoplay: 1,
                                    muted: true
                                },
                                url: videos[activeIndex].url
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageZoom/* default */.Z, {
                            width: 2200,
                            onClick: ()=>setShowGallery(true),
                            image: images[activeIndex - videos.length]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGlide, ProductImages_objectSpreadProps(ProductImages_objectSpread({
                bound: true,
                gap: 8,
                perView: 4
            }, displayItems.length <= 4 && {
                showControl: false,
                dragThreshold: false,
                swipeThreshold: false
            }), {
                displayNewLayout: true,
                children: renderDisplayItems()
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay_es/* Overlay */.a, {
                show: showGallery,
                onEscPressed: ()=>setShowGallery(false),
                children: !!images.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery_es/* Gallery */.r, {
                    images: images,
                    videos: videos === null || videos === void 0 ? void 0 : videos.map((video)=>{
                        return ProductImages_objectSpreadProps(ProductImages_objectSpread({}, video), {
                            src: video.url
                        });
                    }),
                    bgColor: "white",
                    onClose: ()=>setShowGallery(false),
                    activeImageIndex: activeIndex
                }) : null
            })
        ]
    }));
};
const FrameWrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { frame  } = param;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  background-image: url(".concat(frame, ");\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  ");
});
const StyledYoutubeThumbnail = (0,emotion_styled_browser_esm["default"])(YoutubeIframe_es/* YoutubeThumbnail */.F)((param)=>{
    let { isActive , theme  } = param;
    return "\n  border: 1.5px solid\n    ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#dddddd", ";\n");
});
const ThumbnailVideo = (0,emotion_styled_browser_esm["default"])(ProductVideo_es/* ProductVideo */.N)((param)=>{
    let { isActive , theme  } = param;
    return "\n  cursor: pointer;\n  border: 1.5px solid\n    ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#dddddd", ";\n  transition: 0.1s ease opacity;\n  &:hover {\n    opacity: 0.6;\n  }\n");
});
const StyledItemFrame = emotion_styled_browser_esm["default"].div(ProductImages_templateObject());
const StyledGlide = (0,emotion_styled_browser_esm["default"])(Glide_es/* Glide */.A)(ProductImages_templateObject1());

// EXTERNAL MODULE: ./modules/product-detail/hooks/useProductRecipes.ts
var useProductRecipes = __webpack_require__(199184);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRecipes.tsx
function ProductRecipes_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductRecipes_templateObject() {
    const data = ProductRecipes_taggedTemplateLiteral([
        "\n  border: 1px groove;\n  border-radius: 16px;\n"
    ]);
    ProductRecipes_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductRecipes_templateObject1() {
    const data = ProductRecipes_taggedTemplateLiteral([
        "\n  padding: 8px;\n  background-color: #f5f5f5;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  display: flex;\n  align-items: center;\n"
    ]);
    ProductRecipes_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductRecipes_templateObject2() {
    const data = ProductRecipes_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 120px;\n  height: 120px;\n  overflow: visible;\n  border-radius: 16px;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  .dish-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    border-radius: 16px;\n  }\n  .dish-name {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 4px 6px;\n    background-color: rgba(0, 0, 0, 0.6);\n    color: #fff;\n    text-align: left;\n    width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    line-height: 21px;\n  }\n  // style for selected dish (recipe)\n  &.selected {\n    border: 1.5px solid #0200bc;\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: -24;\n      left: 50%;\n      transform: translateX(-50%);\n      width: 0;\n      height: 0;\n      border-left: 16px solid transparent;\n      border-right: 16px solid transparent;\n      border-bottom: 24px solid #f5f5f5;\n    }\n  }\n"
    ]);
    ProductRecipes_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductRecipes_templateObject3() {
    const data = ProductRecipes_taggedTemplateLiteral([
        "\n  border-radius: 1000px;\n  flex: 0 0 auto; /* kh\xf4ng co k\xe9o để giữ k\xedch thước nội dung */\n  white-space: nowrap;\n  cursor: pointer;\n"
    ]);
    ProductRecipes_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductRecipes_templateObject4() {
    const data = ProductRecipes_taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n"
    ]);
    ProductRecipes_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = ProductRecipes_taggedTemplateLiteral([
        "\n  .horizontal-slider,\n  .glide__track {\n    border-radius: 12px !important;\n    max-width: 100%;\n  }\n  .glide__arrow--override {\n    width: 40px !important;\n    height: 40px !important;\n  }\n  .glide__arrow--left {\n    left: -6px !important;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n    &:after {\n      height: 24px !important;\n      width: 24px !important;\n    }\n  }\n  .glide__arrow--right {\n    right: -6px !important;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n    &:after {\n      height: 24px !important;\n      width: 24px !important;\n    }\n  }\n  .glide__slides {\n    margin: 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








const ProductRecipes = ()=>{
    const { displayNewLayout  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const router = (0,next_router.useRouter)();
    const { selectedRecipe , setSelectedRecipe , orderedMaterials , cookingRecipes ,  } = (0,useProductRecipes/* useProductRecipes */.K)();
    return cookingRecipes.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        padding: [
            "s8",
            "s0"
        ],
        marginTop: "s8",
        backgroundColor: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductRecipes_StyledContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                        level: 2,
                        children: (0,i18n.t)("Kh\xe1m ph\xe1 m\xf3n ngon")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                    padding: "s8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Glide_es/* Glide */.A, {
                            perView: (0,helpers/* isServerless */.ep)() && window.innerWidth <= 1440 ? 5.5 : 7,
                            showControl: false,
                            style: {
                                height: "136px"
                            },
                            children: cookingRecipes.map((recipe, index)=>{
                                var ref, ref1;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(DishCard, {
                                    className: recipe.id === (selectedRecipe === null || selectedRecipe === void 0 ? void 0 : selectedRecipe.id) ? "selected" : "",
                                    onClick: ()=>{
                                        setSelectedRecipe(recipe);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                                            className: "dish-image",
                                            src: ((ref = recipe.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                            className: "dish-name",
                                            level: 1,
                                            line: 2,
                                            children: recipe.title
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                            backgroundColor: "#F5F5F5",
                            width: "100%",
                            borderRadius: "m",
                            padding: "s8",
                            children: [
                                !!(selectedRecipe === null || selectedRecipe === void 0 ? void 0 : selectedRecipe.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    marginBottom: "s8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionRecipe, {
                                        level: 1,
                                        children: selectedRecipe === null || selectedRecipe === void 0 ? void 0 : selectedRecipe.description
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    align: "middle",
                                    justify: "space-between",
                                    marginBottom: "s8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                            level: 2,
                                            children: (0,i18n.t)("Nguy\xean liệu")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewRecipeButton, {
                                            variant: "primary",
                                            className: "btn",
                                            height: "2rem",
                                            onClick: ()=>{
                                                router.push((selectedRecipe === null || selectedRecipe === void 0 ? void 0 : selectedRecipe.url) || "/");
                                            },
                                            children: (0,i18n.t)("Xem c\xf4ng thức")
                                        })
                                    ]
                                }),
                                !!(orderedMaterials === null || orderedMaterials === void 0 ? void 0 : orderedMaterials.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductCarousel, {
                                    products: orderedMaterials,
                                    productsPerRow: 4,
                                    regionName: "productRecipes",
                                    desktopProps: {
                                        perSwipe: "",
                                        bound: true,
                                        displayNewLayout
                                    }
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    }) : null;
};
const ProductRecipes_StyledContent = emotion_styled_browser_esm["default"].div(ProductRecipes_templateObject());
const StyledHeaderContent = emotion_styled_browser_esm["default"].div(ProductRecipes_templateObject1());
const DishCard = emotion_styled_browser_esm["default"].div(ProductRecipes_templateObject2());
const ViewRecipeButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(ProductRecipes_templateObject3());
const DescriptionRecipe = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Body */.uT)(ProductRecipes_templateObject4());
const StyledProductCarousel = (0,emotion_styled_browser_esm["default"])(ProductCarousel_es/* ProductCarousel */.G)(_templateObject5());

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/QuantityBlock.tsx
function QuantityBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function QuantityBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            QuantityBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function QuantityBlock_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function QuantityBlock_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        QuantityBlock_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function QuantityBlock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function QuantityBlock_templateObject() {
    const data = QuantityBlock_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  margin-bottom: 16px;\n  .quantity-text {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    margin-right: 8px;\n    white-space: nowrap;\n  }\n  .quantity-selector {\n    width: 132px !important;\n    height: 36px !important;\n    .rc-input-number-input {\n      border-left: 1px solid #e4e5f0;\n      border-right: 1px solid #e4e5f0;\n      background-color: white;\n    }\n  }\n"
    ]);
    QuantityBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const QuantityBlock_QuantityBlock = ()=>{
    const { product , payloadAddToCart , setPayloadAddToCart  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { uomCodeToDisplayDecimalQuantity  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const precision = (product === null || product === void 0 ? void 0 : product.uomCode) === uomCodeToDisplayDecimalQuantity ? 3 : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityBlock_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "quantity-text",
                children: (0,i18n.t)("Số lượng")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, QuantityBlock_objectSpreadProps(QuantityBlock_objectSpread({
                className: "quantity-selector",
                disableMinus: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) === 1,
                quantity: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1,
                setQuantity: (value)=>{
                    if (value !== (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity)) {
                        setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                            return QuantityBlock_objectSpreadProps(QuantityBlock_objectSpread({}, prev), {
                                quantity: value
                            });
                        });
                    }
                },
                onPlus: ()=>{
                    setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                        return QuantityBlock_objectSpreadProps(QuantityBlock_objectSpread({}, prev), {
                            quantity: (prev.quantity || 1) + 1
                        });
                    });
                },
                onMinus: ()=>{
                    if (((payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1) - 1 > 0) {
                        setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                            return QuantityBlock_objectSpreadProps(QuantityBlock_objectSpread({}, prev), {
                                quantity: (prev.quantity || 1) - 1
                            });
                        });
                    }
                },
                min: Math.pow(10, -precision)
            }, (0,env/* getEnv */.dU)("EPIC_ECOM_489") !== "enabled" ? {
                decimalSeparator: "."
            } : {}), {
                precision: precision,
                blurOnEnter: true
            }))
        ]
    });
};
const QuantityBlock_Wrapper = emotion_styled_browser_esm["default"].div(QuantityBlock_templateObject());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/GreenGiffColored.es.js
var GreenGiffColored_es = __webpack_require__(831026);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UpOutlined.es.js
var UpOutlined_es = __webpack_require__(994734);
// EXTERNAL MODULE: ./components/RelatedPromotionV2.tsx
var RelatedPromotionV2 = __webpack_require__(590498);
// EXTERNAL MODULE: ./hooks/useDetailPromotion.tsx + 1 modules
var useDetailPromotion = __webpack_require__(170604);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/RelatedPromotions.tsx
function RelatedPromotions_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RelatedPromotions_templateObject() {
    const data = RelatedPromotions_taggedTemplateLiteral([
        "\n  border: 1px groove;\n  border-radius: 16px;\n"
    ]);
    RelatedPromotions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RelatedPromotions_templateObject1() {
    const data = RelatedPromotions_taggedTemplateLiteral([
        "\n  padding: 8px;\n  background-color: #f5f5f5;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  display: flex;\n  align-items: center;\n"
    ]);
    RelatedPromotions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RelatedPromotions_templateObject2() {
    const data = RelatedPromotions_taggedTemplateLiteral([
        "\n  width: fit-content;\n  margin: 0.5rem auto;\n"
    ]);
    RelatedPromotions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RelatedPromotions_templateObject3() {
    const data = RelatedPromotions_taggedTemplateLiteral([
        "\n  margin: 0;\n  padding-left: 0; // remove default padding of ul\n  margin-left: 2rem;\n"
    ]);
    RelatedPromotions_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








const RelatedPromotions = ()=>{
    const { 0: showAllPromotions , 1: setShowAllPromotions  } = (0,react.useState)(false);
    const { product , price  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { validPromotions  } = (0,useDetailPromotion/* useDetailPromotion */.n)(product, price === null || price === void 0 ? void 0 : price.finalPrice);
    const displayedPromotions = showAllPromotions ? validPromotions : [
        ...validPromotions.slice(0, 3)
    ];
    return !!(validPromotions === null || validPromotions === void 0 ? void 0 : validPromotions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        padding: [
            "s8",
            "s0"
        ],
        marginTop: "s8",
        backgroundColor: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RelatedPromotions_StyledContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RelatedPromotions_StyledHeaderContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenGiffColored_es/* GreenGiffColored */.f, {
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                            level: 2,
                            marginLeft: "s8",
                            children: (0,i18n.t)("Khuyến m\xe3i li\xean quan")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                    padding: "s8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUl, {
                            children: displayedPromotions.map((promotion, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        fontSize: "14px",
                                        lineHeight: "20px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPromotionV2/* RelatedPromotionV2 */.u, {
                                        validPromotion: promotion
                                    })
                                }, index))
                        }),
                        validPromotions.length > 3 && !showAllPromotions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandCollapseButton, {
                            onClick: (e)=>{
                                e.stopPropagation();
                                setShowAllPromotions(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                level: 1,
                                color: "primary",
                                children: [
                                    (0,i18n.t)("Xem th\xeam"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                                        size: 16,
                                        color: "primary"
                                    })
                                ]
                            })
                        }),
                        showAllPromotions && validPromotions.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandCollapseButton, {
                            onClick: (e)=>{
                                e.stopPropagation();
                                setShowAllPromotions(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                level: 1,
                                color: "primary",
                                children: [
                                    (0,i18n.t)("Thu gọn"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined_es/* UpOutlined */.X, {
                                        size: 16,
                                        color: "primary"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
const RelatedPromotions_StyledContent = emotion_styled_browser_esm["default"].div(RelatedPromotions_templateObject());
const RelatedPromotions_StyledHeaderContent = emotion_styled_browser_esm["default"].div(RelatedPromotions_templateObject1());
const ExpandCollapseButton = emotion_styled_browser_esm["default"].div(RelatedPromotions_templateObject2());
const StyledUl = emotion_styled_browser_esm["default"].ul(RelatedPromotions_templateObject3());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(54230);
// EXTERNAL MODULE: ./hooks/useComboList.tsx
var useComboList = __webpack_require__(453594);
// EXTERNAL MODULE: ./assets/combo-promotion-v2.svg
var combo_promotion_v2 = __webpack_require__(716955);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(635412);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DiscountColored.es.js
var DiscountColored_es = __webpack_require__(763962);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/VoucherTagColored.es.js
var VoucherTagColored_es = __webpack_require__(624485);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/combo/PromotionBenefitInfo.tsx







const PromotionBenefitInfo = (props)=>{
    const { numberDisplayFormat  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { promotionBenefit , showFullBenefits: initialShowFullBenefits  } = props;
    const { 0: showFullBenefits , 1: setShowFullBenefits  } = (0,react.useState)(initialShowFullBenefits);
    const getBenefits = (benefit)=>{
        let count = 0;
        const benefits = [];
        const { discount , voucher , gifts  } = benefit;
        const discountValue = (discount === null || discount === void 0 ? void 0 : discount.flat) || (discount === null || discount === void 0 ? void 0 : discount.percent) || 0;
        if (discount && discountValue > 0) {
            count++;
            benefits.push({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountColored_es/* DiscountColored */.P, {
                        size: 24
                    })
                }),
                name: "".concat((0,i18n.t)("Giảm ngay"), " ").concat((discount === null || discount === void 0 ? void 0 : discount.flat) ? (0,number_es/* formatCurrency */.xG)(discountValue, numberDisplayFormat) : "".concat(discountValue, "%") + (discount.maxAmount ? " ".concat((0,i18n.t)("Giảm tối đa"), " ").concat((0,number_es/* formatCurrency */.xG)(discount.maxAmount, numberDisplayFormat)) : ""))
            });
        }
        if (voucher) {
            count++;
            benefits.push({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherTagColored_es/* VoucherTagColored */.H, {
                        size: 24
                    })
                }),
                name: voucher.name,
                quantity: voucher.quantity
            });
        }
        if (gifts && !!gifts.length) {
            count++;
            gifts.forEach((gift)=>{
                benefits.push({
                    image: gift.imageUrl,
                    name: gift.name,
                    quantity: gift.quantity
                });
            });
        }
        return {
            numberOfBenefit: count,
            benefits
        };
    };
    const benefits = getBenefits(promotionBenefit).benefits;
    return benefits.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
        direction: "column",
        gap: "s4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                border: "1px solid #ffa39e",
                borderRadius: "m",
                style: {
                    padding: "2px 8px",
                    background: "#FFF1F0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                    level: 1,
                    color: "#f5222d",
                    children: (0,i18n.t)("NHẬN NGAY ƯU Đ\xc3I")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                direction: "column",
                gap: "s4",
                children: benefits.slice(0, showFullBenefits ? benefits.length : 3).map((param, index)=>/*#__PURE__*/ {
                    let { name , image , quantity , icon  } = param;
                    return (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        height: "24px",
                        align: "center",
                        children: [
                            icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: icon
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                borderRadius: "8px",
                                src: image || "",
                                width: 22,
                                height: 22
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                level: 1,
                                line: 2,
                                marginLeft: "s8",
                                children: [
                                    quantity && quantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#2b2b2b"
                                        },
                                        children: "Tặng ".concat(quantity, " x ")
                                    }),
                                    name
                                ]
                            })
                        ]
                    }, "".concat(index).concat(name));
                })
            }),
            benefits.length > 3 && !initialShowFullBenefits && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                children: !showFullBenefits ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                    color: "textSecondary",
                    level: 1,
                    onClick: ()=>setShowFullBenefits(true),
                    children: (0,i18n.t)("Xem th\xeam")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                    color: "textSecondary",
                    level: 1,
                    onClick: ()=>setShowFullBenefits(false),
                    children: (0,i18n.t)("R\xfat gọn")
                })
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/combo/ComboItem.tsx
function ComboItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ComboItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ComboItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ComboItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ComboItem_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ComboItem_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ComboItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ComboItem_templateObject() {
    const data = ComboItem_taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 16px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  color: white;\n  padding: 2px 5px;\n  top: 4px;\n  left: 4px;\n"
    ]);
    ComboItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ComboItem_templateObject1() {
    const data = ComboItem_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 88px;\n  height: 88px;\n  background-color: rgba(27, 29, 41, 0.5);\n  color: #ffffff;\n  z-index: 1;\n  top: 6px;\n  left: 6px;\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n"
    ]);
    ComboItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ComboItem_templateObject2() {
    const data = ComboItem_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 88px;\n  height: 88px;\n  top: 6px;\n  left: 6px;\n  opacity: 80%;\n  background: #1b1d29;\n  border-radius: 4px;\n"
    ]);
    ComboItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ComboItem_templateObject3() {
    const data = ComboItem_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    ComboItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ComboItem_templateObject4() {
    const data = ComboItem_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    ComboItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ComboItem_templateObject5() {
    const data = ComboItem_taggedTemplateLiteral([
        "\n  position: relative;\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    top: 32px;\n    border-right: 1px solid #e4e5f0;\n    height: 40px;\n  }\n"
    ]);
    ComboItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







const MAX_CONDITION_ITEMS = 3;
const ComboItem = (props)=>{
    const { combo , onClickProductChange  } = props;
    const { totalProduct , promotion , conditions  } = combo;
    const displayConditionItems = conditions.length > MAX_CONDITION_ITEMS ? conditions.slice(0, MAX_CONDITION_ITEMS - 1) : conditions;
    const residualProducts = conditions.length > MAX_CONDITION_ITEMS ? conditions.slice(MAX_CONDITION_ITEMS - 1).map((residualProduct, index)=>ComboItem_objectSpreadProps(ComboItem_objectSpread({}, residualProduct), {
            tracking: (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "productComboList",
                contentName: "btnChangeProductCombo",
                payload: JSON.stringify({
                    comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                    promotionType: "combo",
                    skuIndex: MAX_CONDITION_ITEMS + index,
                    sku: residualProduct.product.sku
                })
            })
        })) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
            padding: [
                "s8",
                "s40"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                gap: "s32",
                padding: [
                    "s0",
                    "s32"
                ],
                align: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        align: "center",
                        gap: "s16",
                        children: [
                            displayConditionItems.map((conditionItem, index)=>{
                                const { product , requiredQuantity , key  } = conditionItem;
                                const isLastItem = !!residualProducts.length ? false : index === displayConditionItems.length - 1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionItem, {
                                            conditionKey: key,
                                            product: product,
                                            requiredQuantity: requiredQuantity,
                                            onClickProductChange: onClickProductChange,
                                            tracking: (0,helper_es/* getTrackingData */.O5)({
                                                isTrackContent: true,
                                                regionName: "productComboList",
                                                contentName: "btnChangeProductCombo",
                                                payload: JSON.stringify({
                                                    comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                                    promotionType: "combo",
                                                    skuIndex: index + 1,
                                                    sku: product.sku
                                                })
                                            })
                                        }, "".concat(index).concat(conditionItem.key)),
                                        !isLastItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            width: "40px",
                                            height: "40px",
                                            backgroundColor: "background",
                                            align: "center",
                                            justify: "center",
                                            style: {
                                                borderRadius: "999px",
                                                fontSize: "20px"
                                            },
                                            children: "+"
                                        }) : null
                                    ]
                                });
                            }),
                            !!residualProducts.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactedConditionItem, {
                                residualProducts: residualProducts,
                                onClickProductChange: onClickProductChange
                            })
                        ]
                    }),
                    !!promotion.benefit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionBenefitWrapper, {
                        paddingLeft: "s32",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionBenefitInfo, {
                            promotionBenefit: promotion.benefit
                        })
                    }) : null
                ]
            })
        })
    });
};
const ConditionItem = (props)=>{
    var ref, ref1;
    const { product , requiredQuantity , conditionPromotion , tracking , conditionKey , onClickProductChange ,  } = props;
    const { imageUrl , name , price , sku  } = product;
    const { numberDisplayFormat , applyNewLogicToCalculateComboPrice  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const latestPrice = applyNewLogicToCalculateComboPrice || !(conditionPromotion === null || conditionPromotion === void 0 ? void 0 : (ref = conditionPromotion.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.exclusions) === null || ref1 === void 0 ? void 0 : ref1.length) ? price.latestPrice : price.supplierRetailPrice;
    const link = {
        href: {
            pathname: "/products/".concat(sku)
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, ComboItem_objectSpreadProps(ComboItem_objectSpread({}, link), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            width: "320px",
            height: "104px",
            borderRadius: "xl",
            border: "1px solid divider",
            gap: "s8",
            padding: "s8",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            width: "88px",
                            height: "88px",
                            src: imageUrl,
                            hover: "zoom",
                            contain: true,
                            aspectRatio: 1,
                            alt: name,
                            borderRadius: 4
                        }),
                        requiredQuantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityTag, {
                            backgroundColor: "primary500",
                            children: [
                                requiredQuantity,
                                "x"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "column",
                    justify: "space-between",
                    height: "100%",
                    width: "208px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            level: 1,
                            line: 2,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "row",
                            height: "40px",
                            align: "end",
                            justify: "space-between",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice_es/* ProductPrice */.j, {
                                    latestPrice: latestPrice,
                                    supplierRetailPrice: price.supplierRetailPrice > latestPrice ? price.supplierRetailPrice : undefined,
                                    textColor: "textPrimary",
                                    numberDisplayFormat: numberDisplayFormat
                                }),
                                conditionKey > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, ComboItem_objectSpreadProps(ComboItem_objectSpread({}, tracking), {
                                    onClick: (event)=>{
                                        event.preventDefault();
                                        onClickProductChange(sku, conditionKey);
                                    },
                                    variant: "primary",
                                    style: {
                                        height: "24px",
                                        padding: "0px 8px",
                                        borderRadius: "9999px"
                                    },
                                    children: (0,i18n.t)("Thay đổi")
                                }))
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
const CompactedConditionItem = (props)=>{
    const { residualProducts , onClickProductChange  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactedConditionItemWrapper, {
        width: "104px",
        height: "104px",
        padding: "s8",
        border: "1px solid background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_es/* Dropdown */.L, {
            placement: "left",
            menu: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                width: "336px",
                style: {
                    zIndex: 9999999
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                        padding: [
                            "s8",
                            "s16"
                        ],
                        marginBottom: "s8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                            children: (0,i18n.t)("Sản phẩm trong combo")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        gap: "s8",
                        padding: [
                            "s0",
                            "s8"
                        ],
                        direction: "column",
                        children: residualProducts.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                href: "/products/".concat(item.product.sku),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionItem, {
                                    conditionKey: item.key,
                                    product: item.product,
                                    requiredQuantity: item.requiredQuantity,
                                    tracking: item.tracking,
                                    onClickProductChange: onClickProductChange
                                })
                            }, "".concat(index).concat(item.key)))
                    })
                ]
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainCoverWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                        width: "88px",
                        height: "88px",
                        src: residualProducts[0].product.imageUrl,
                        hover: "zoom",
                        contain: true,
                        aspectRatio: 1,
                        alt: residualProducts[0].product.name,
                        borderRadius: 4
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRemainBg, {
                    children: [
                        "+",
                        residualProducts.length
                    ]
                })
            ]
        })
    });
};
const QuantityTag = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboItem_templateObject());
const StyledRemainBg = emotion_styled_browser_esm["default"].div(ComboItem_templateObject1());
const RemainCoverWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboItem_templateObject2());
const ImageWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboItem_templateObject3());
const CompactedConditionItemWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboItem_templateObject4());
const PromotionBenefitWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboItem_templateObject5());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(651337);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/TickFilled.es.js
var TickFilled_es = __webpack_require__(627530);
// EXTERNAL MODULE: ./helpers/combo.ts
var helpers_combo = __webpack_require__(662295);
// EXTERNAL MODULE: ./modules/cart/utils/index.ts
var utils = __webpack_require__(739069);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/combo/ComboSelectionModal.tsx
function ComboSelectionModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ComboSelectionModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ComboSelectionModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ComboSelectionModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ComboSelectionModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ComboSelectionModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ComboSelectionModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ComboSelectionModal_templateObject() {
    const data = ComboSelectionModal_taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 16px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  color: white;\n  padding: 2px 5px;\n  top: 8px;\n  left: 8px;\n"
    ]);
    ComboSelectionModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ComboSelectionModal_templateObject1() {
    const data = ComboSelectionModal_taggedTemplateLiteral([
        "\n  padding: 8px;\n  .glide__track {\n    padding: 8px;\n    background-color: #f5f5f5;\n    border-radius: 12px;\n  }\n"
    ]);
    ComboSelectionModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












const ComboSelectionModal = (props)=>{
    const { visible , activeCombo , selectingProduct , closeModal , comboGroup , setActiveCombo , setComboGroup , handleConfirm , productCombos , showAddComboToCartButton =true , showAllCombos ,  } = props;
    const { onAddComboItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    const { numberDisplayFormat , applyNewLogicToCalculateComboPrice =false  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    // Index of condition in its combo.
    // If user do not select any condition, default is the first condition in combo immediately after main product (main product's index is 0)
    const { 0: conditionIndex , 1: setConditionIndex  } = (0,react.useState)(selectingProduct ? selectingProduct.conditionKey - 1 : 1);
    const { 0: selectingComboProduct , 1: setSelectingComboProduct  } = (0,react.useState)();
    const { 0: selectingCombo , 1: setSelectingCombo  } = (0,react.useState)(activeCombo);
    const updateActiveAndGroupCombo = ()=>{
        if (comboGroup && selectingCombo && selectingComboProduct) {
            const selectedGroup = comboGroup[selectingCombo.totalProduct];
            setActiveCombo(selectingCombo);
            setComboGroup(ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, comboGroup), {
                [selectingCombo.totalProduct]: {
                    combos: selectedGroup.combos.map((cb)=>cb.key === selectingCombo.key ? selectingCombo : cb)
                }
            }));
        }
    };
    const addComboToCart = async ()=>{
        if (selectingCombo) {
            updateActiveAndGroupCombo();
            const mainPayload = {
                override: true,
                groups: [
                    {
                        quantity: 1,
                        promotionId: selectingCombo.promotion.id,
                        products: selectingCombo.conditions.map((el, index)=>{
                            var ref, ref1;
                            return {
                                sku: el.product.sku,
                                promotionId: !!((ref = el.product.bestPromotionIds) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = el.product.bestPromotionIds) === null || ref1 === void 0 ? void 0 : ref1[0] : null,
                                quantity: el.requiredQuantity,
                                isPrimary: index === 0
                            };
                        })
                    }, 
                ]
            };
            await onAddComboItems(mainPayload, false);
            closeModal(selectingCombo);
        }
    };
    // Trigger open this modal, if have no active combo -> set default active combo is the first combo in productCombos
    (0,react.useEffect)(()=>{
        if (visible && !activeCombo && (productCombos === null || productCombos === void 0 ? void 0 : productCombos.length)) {
            const comboTemp = ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, productCombos[0]), {
                conditions: productCombos[0].conditions.map((_param)=>{
                    var { products  } = _param, restCondition = _objectWithoutProperties(_param, [
                        "products"
                    ]);
                    return ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, restCondition), {
                        product: products[0]
                    });
                })
            });
            const defaultCombo = ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, comboTemp), {
                discountByCombo: (0,helpers_combo/* getDiscountByCombo */.qE)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalDiscount: (0,helpers_combo/* getTotalDiscount */.bb)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalAmount: (0,helpers_combo/* getTotalAmount */.aU)(comboTemp, applyNewLogicToCalculateComboPrice)
            });
            setActiveCombo(defaultCombo);
            setSelectingCombo(defaultCombo);
        }
    }, [
        activeCombo,
        visible
    ]);
    (0,react.useEffect)(()=>{
        if (!selectingComboProduct) {
            if (selectingProduct) {
                setSelectingComboProduct(selectingProduct);
            } else {
                if (activeCombo) {
                    var ref, ref1;
                    setSelectingComboProduct({
                        sku: (ref = activeCombo.conditions[1]) === null || ref === void 0 ? void 0 : ref.product.sku,
                        conditionKey: (ref1 = activeCombo.conditions[1]) === null || ref1 === void 0 ? void 0 : ref1.key
                    });
                }
            }
        }
    }, [
        activeCombo,
        selectingProduct
    ]);
    const selectComboProduct = (product, cb)=>{
        if (selectingCombo) {
            // build new active combo based on the new selected product
            const comboTemp = ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, cb), {
                // Check if the select combo product in still in side the previous combo
                conditions: selectingCombo.key === cb.key ? selectingCombo.conditions.map((condition, index)=>{
                    return {
                        key: condition.key,
                        requiredQuantity: condition.requiredQuantity,
                        product: index === conditionIndex ? product : condition.product
                    };
                }) : // reset other indexes in active combo to products[0]
                cb.conditions.map((condition, index)=>{
                    return {
                        key: condition.key,
                        requiredQuantity: condition.requiredQuantity,
                        product: index === conditionIndex ? product : condition.products[0]
                    };
                })
            });
            const newActiveCombo = ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, comboTemp), {
                discountByCombo: (0,helpers_combo/* getDiscountByCombo */.qE)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalDiscount: (0,helpers_combo/* getTotalDiscount */.bb)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalAmount: (0,helpers_combo/* getTotalAmount */.aU)(comboTemp, applyNewLogicToCalculateComboPrice)
            });
            setSelectingCombo(newActiveCombo);
            setSelectingComboProduct({
                sku: product.sku,
                conditionKey: cb.conditions[conditionIndex].key
            });
        }
    };
    // List of combos have same product quantity with active combo
    const similarCombos = (0,react.useMemo)(()=>{
        if (selectingCombo && (productCombos === null || productCombos === void 0 ? void 0 : productCombos.length)) {
            return showAllCombos ? productCombos : productCombos.filter((item)=>item.totalProduct === selectingCombo.totalProduct);
        }
        return [];
    }, [
        selectingCombo,
        productCombos
    ]);
    return selectingCombo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({
        visible: visible && !!activeCombo && !!selectingProduct,
        overlayAlignItems: "start",
        overlayJustifyContent: "end",
        onClose: closeModal,
        footer: false,
        style: {
            height: "100vh",
            padding: "16px"
        },
        contentStyle: {
            height: "100%",
            padding: "16px"
        }
    }, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        contentName: "popupChangeProductCombo",
        regionName: "detailProductComboList"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                style: {
                    textAlign: "start",
                    padding: "0px"
                },
                marginBottom: "s16",
                children: (0,i18n.t)("Chọn sản phẩm trong Combo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
                maxHeight: "calc(100vh - 250px)",
                style: {
                    overflowY: "scroll",
                    padding: "16px"
                },
                children: similarCombos.map((combo, index)=>{
                    var ref, ref1, ref2;
                    // not render combo if condition at conditionIndex not have any products
                    if (!((ref = combo.conditions[conditionIndex]) === null || ref === void 0 ? void 0 : ref.products.length)) {
                        return;
                    }
                    const isSelectingCombo = combo.key === (selectingCombo === null || selectingCombo === void 0 ? void 0 : selectingCombo.key) && combo.conditions[conditionIndex].key === (selectingComboProduct === null || selectingComboProduct === void 0 ? void 0 : selectingComboProduct.conditionKey) && ((ref1 = combo.conditions[conditionIndex]) === null || ref1 === void 0 ? void 0 : ref1.products.findIndex((p)=>{
                        return p.sku === (selectingComboProduct === null || selectingComboProduct === void 0 ? void 0 : selectingComboProduct.sku);
                    })) > -1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({
                        borderRadius: "xl",
                        border: "1px solid divider",
                        marginBottom: index !== similarCombos.length - 1 ? "s16" : "s0"
                    }, (0,helper_es/* getTrackingData */.O5)({
                        isTrackContent: true,
                        contentName: "blockComboPromotion".concat(index + 1),
                        regionName: "detailProductComboList",
                        payload: JSON.stringify({
                            comboIndex: index + 1
                        })
                    })), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                align: "center",
                                justify: "space-between",
                                backgroundColor: "background",
                                padding: "s8",
                                style: {
                                    borderRadius: "16px 16px 0px 0px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* SubTitle */.DK, {
                                        level: 2,
                                        marginLeft: "s4",
                                        children: [
                                            "Combo ",
                                            index + 1
                                        ]
                                    }),
                                    isSelectingCombo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TickFilled_es/* TickFilled */.i, {
                                        size: "24",
                                        color: "primary"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                                        height: "24px",
                                        width: "24px",
                                        border: "1px solid disable",
                                        style: {
                                            borderRadius: "9999px"
                                        }
                                    })
                                ]
                            }),
                            combo.promotion.benefit && (0,helpers_combo/* countAndGetBenefitDescription */.sE)(combo.promotion.benefit, numberDisplayFormat).numberOfBenefit >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                                padding: "s8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionBenefitInfo, {
                                    promotionBenefit: combo.promotion.benefit,
                                    showFullBenefits: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboSelectionModal_StyledGlide, {
                                perView: 2.3,
                                displayNewLayout: true,
                                children: (ref2 = combo.conditions[conditionIndex]) === null || ref2 === void 0 ? void 0 : ref2.products.map((product, productIndex)=>{
                                    var ref, ref1;
                                    const productLink = (0,utils/* getConditionProductLinkObj */.lL)(product);
                                    const isSelectedProduct = combo.key === (selectingCombo === null || selectingCombo === void 0 ? void 0 : selectingCombo.key) && combo.conditions[conditionIndex].key === (selectingComboProduct === null || selectingComboProduct === void 0 ? void 0 : selectingComboProduct.conditionKey) && product.sku === (selectingComboProduct === null || selectingComboProduct === void 0 ? void 0 : selectingComboProduct.sku);
                                    const latestPrice = applyNewLogicToCalculateComboPrice || !((ref = combo.promotion.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.exclusions) === null || ref1 === void 0 ? void 0 : ref1.length) ? product.price.latestPrice : product.price.supplierRetailPrice;
                                    const requiredQuantity = combo.conditions[conditionIndex].requiredQuantity;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                                        backgroundColor: "white",
                                        borderRadius: "s",
                                        padding: "s8",
                                        style: {
                                            position: "relative"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink_es/* CustomLink */.x, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, productLink), {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                                        src: product.imageUrl,
                                                        hover: "zoom",
                                                        contain: true,
                                                        alt: product.name,
                                                        aspectRatio: 1,
                                                        width: "100%"
                                                    }),
                                                    requiredQuantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComboSelectionModal_QuantityTag, {
                                                        backgroundColor: "primary500",
                                                        children: [
                                                            requiredQuantity,
                                                            "x"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                        hoverColor: "primary500",
                                                        marginTop: "s8",
                                                        level: 1,
                                                        line: 3,
                                                        color: "#434657",
                                                        height: 60,
                                                        children: product.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            width: "100%",
                                                            alignItems: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice_es/* ProductPrice */.j, {
                                                            latestPrice: latestPrice,
                                                            supplierRetailPrice: product.price.supplierRetailPrice > latestPrice ? product.price.supplierRetailPrice : undefined,
                                                            numberDisplayFormat: numberDisplayFormat
                                                        })
                                                    })
                                                ]
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                                                isTrackContent: true,
                                                contentName: "selectProduct",
                                                regionName: "detailProductComboList",
                                                payload: JSON.stringify({
                                                    comboIndex: index + 1,
                                                    skuIndex: productIndex + 1,
                                                    sku: product.sku
                                                })
                                            })), {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                                    variant: "secondary",
                                                    width: "100%",
                                                    marginTop: "s8",
                                                    onClick: ()=>selectComboProduct(product, combo),
                                                    disabled: isSelectedProduct,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                                        level: 4,
                                                        weight: "medium",
                                                        children: isSelectedProduct ? (0,i18n.t)("Đ\xe3 chọn") : (0,i18n.t)("Chọn")
                                                    })
                                                })
                                            }))
                                        ]
                                    }, "".concat(index).concat(productIndex).concat(product.sku));
                                })
                            })
                        ]
                    }), "".concat(index).concat(combo.key));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalFooter_es/* ModalFooter */.m, {
                height: "144px",
                borderTop: "1px solid #E4E5F0",
                style: {
                    padding: "16px 0 0 0",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        gap: "s12",
                        height: "48px",
                        width: "100%",
                        padding: [
                            "s0",
                            "s16"
                        ],
                        children: selectingCombo.conditions.map((condition, index)=>{
                            return /*#__PURE__*/ (0,react.createElement)(index_es/* Shape */.b, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                                isTrackContent: true,
                                contentName: "changeProductInCombo",
                                regionName: "detailProductComboList",
                                payload: JSON.stringify({
                                    skuComboIndex: index + 1
                                })
                            })), {
                                key: "".concat(index).concat(condition.key),
                                padding: "s4",
                                height: "100%",
                                width: "48px",
                                border: index === conditionIndex ? "1px solid primary" : "1px solid divider",
                                borderRadius: "m",
                                opacity: index === 0 ? "l" : undefined
                            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                src: condition.product.imageUrl,
                                borderRadius: 8,
                                contain: true,
                                width: "100%",
                                aspectRatio: 1,
                                onClick: index !== 0 ? ()=>{
                                    setConditionIndex(index);
                                    setSelectingComboProduct({
                                        sku: condition.product.sku,
                                        conditionKey: condition.key
                                    });
                                } : undefined
                            }, index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        align: "center",
                        justify: "space-between",
                        width: "100%",
                        padding: "s16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                level: 1,
                                                marginRight: "s4",
                                                children: "".concat((0,i18n.t)("Tổng tiền"), ":")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                                level: 1,
                                                color: "primary500",
                                                children: (0,number_es/* formatCurrency */.xG)(selectingCombo.totalAmount, numberDisplayFormat)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                level: 1,
                                                marginRight: "s8",
                                                children: "".concat((0,i18n.t)("Tiết kiệm"), ":")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                level: 1,
                                                children: (0,number_es/* formatCurrency */.xG)(selectingCombo.totalDiscount, numberDisplayFormat)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                gap: "s4",
                                children: [
                                    showAddComboToCartButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                                        isTrackContent: true,
                                        contentName: "btnAddToCart",
                                        regionName: "detailProductComboList",
                                        payload: JSON.stringify({
                                            promotionType: "combo",
                                            comboTab: "Combo ".concat(selectingCombo.totalProduct, " sản phẩm"),
                                            comboPromotion: selectingCombo.promotion.id,
                                            comboIndex: selectingCombo.key,
                                            skus: selectingCombo.conditions.map((c)=>c.product.sku)
                                        })
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                            variant: "secondary",
                                            onClick: addComboToCart,
                                            children: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, ComboSelectionModal_objectSpreadProps(ComboSelectionModal_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                                        isTrackContent: true,
                                        contentName: "btnConfirmCombo",
                                        regionName: "detailProductComboList",
                                        payload: JSON.stringify({
                                            comboPromotion: selectingCombo.promotion.id
                                        })
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                            variant: "primary",
                                            onClick: ()=>{
                                                updateActiveAndGroupCombo();
                                                handleConfirm === null || handleConfirm === void 0 ? void 0 : handleConfirm(selectingCombo);
                                                closeModal(selectingCombo);
                                                setSelectingComboProduct(undefined);
                                                setSelectingCombo(undefined);
                                            },
                                            children: (0,i18n.t)("X\xe1c nhận")
                                        })
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    })) : null;
};
const ComboSelectionModal_QuantityTag = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboSelectionModal_templateObject());
const ComboSelectionModal_StyledGlide = (0,emotion_styled_browser_esm["default"])(Glide_es/* Glide */.A)(ComboSelectionModal_templateObject1());

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/combo/ComboCarousel.tsx
function ComboCarousel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ComboCarousel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ComboCarousel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ComboCarousel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ComboCarousel_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ComboCarousel_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ComboCarousel_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ComboCarousel_templateObject() {
    const data = ComboCarousel_taggedTemplateLiteral([
        "\n  border-radius: 999px;\n  cursor: pointer;\n"
    ]);
    ComboCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ComboCarousel_templateObject1() {
    const data = ComboCarousel_taggedTemplateLiteral([
        "\n  .glide__track,\n  .glide__slides {\n    overflow-y: unset !important;\n    overflow-x: clip !important;\n  }\n  .glide__arrow--left {\n    top: 60px !important;\n    left: 16px !important;\n  }\n  .glide__arrow--right {\n    top: 40px !important;\n    right: 16px !important;\n  }\n"
    ]);
    ComboCarousel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











const ComboCarousel = ()=>{
    const { numberDisplayFormat  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { onAddComboItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const productComboHook = (0,useComboList/* useProductCombos */.rK)({
        skus: (product === null || product === void 0 ? void 0 : product.sku) ? [
            product.sku
        ] : undefined
    });
    const { activeCombo , setActiveCombo , comboGroup , productCombos  } = productComboHook;
    // activeTab state includes index of currently active tab and total products of each combo in active group
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)({
        index: 0
    });
    // Index of selected slider in Glide on each tab
    const { 0: comboIndex , 1: setComboIndex  } = (0,react.useState)(0);
    // State to keep product sku that user click to "Change product", state also keep both combo key & condition key containing product
    const { 0: selectingProduct , 1: setSelectingProduct  } = (0,react.useState)();
    const { 0: visible , 1: setVisible  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        // set initial activeTab value
        if (comboGroup && !activeTab.totalProductTab) {
            setActiveTab({
                index: 0,
                totalProductTab: Number(Object.keys(comboGroup)[0])
            });
        }
    }, [
        JSON.stringify(comboGroup)
    ]);
    return !!productCombos.length && !!comboGroup && !!activeTab.totalProductTab ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                backgroundColor: "white",
                borderRadius: "xl",
                marginBottom: "s16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        style: {
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#FFF7E6",
                            borderRadius: "16px 16px 0 0",
                            marginBottom: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                src: combo_promotion_v2/* default */.Z,
                                height: 60,
                                width: 132
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Title */.Dx, {
                                style: {
                                    display: "inline",
                                    marginLeft: "8px"
                                },
                                children: (0,i18n.t)("Mua k\xe8m nhận ưu đ\xe3i")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        direction: "column",
                        gap: "s16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                padding: [
                                    "s0",
                                    "s16"
                                ],
                                gap: "s16",
                                children: Object.entries(comboGroup).map((param, index)=>{
                                    let [totalProduct] = param;
                                    const isActiveTab = index === activeTab.index;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboTabWrapper, ComboCarousel_objectSpreadProps(ComboCarousel_objectSpread({
                                        padding: "s8",
                                        border: isActiveTab ? "1px solid primary" : "1px solid divider",
                                        borderRadius: "xl",
                                        onClick: ()=>{
                                            setActiveTab({
                                                index,
                                                totalProductTab: Number(totalProduct)
                                            });
                                            setComboIndex(0);
                                        }
                                    }, (0,helper_es/* getTrackingData */.O5)({
                                        isTrackContent: true,
                                        regionName: "productComboList",
                                        contentName: "btnChangeComboTab",
                                        payload: JSON.stringify({
                                            comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                            comboIndex: index + 1
                                        })
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                            level: isActiveTab ? 2 : 1,
                                            color: isActiveTab ? "primary" : "",
                                            children: (0,i18n.t)("Combo {{totalProduct}} sản phẩm", {
                                                totalProduct
                                            })
                                        })
                                    }), "".concat(index).concat(totalProduct));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlideWrapper, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glide_es/* Glide */.A, {
                                    perView: 1,
                                    startAt: comboIndex,
                                    onSlideChange: (index)=>setComboIndex(index),
                                    displayNewLayout: true,
                                    trackingArrowRight: (0,helper_es/* getTrackingData */.O5)({
                                        isTrackContent: true,
                                        regionName: "productComboList",
                                        contentName: "btnChangeCombo",
                                        payload: JSON.stringify({
                                            comboTab: "Combo ".concat(activeTab.totalProductTab, " sản phẩm"),
                                            comboPromotion: comboGroup[activeTab.totalProductTab].combos[comboIndex].promotion.id,
                                            comboIndex: comboIndex + 1,
                                            target: "next"
                                        })
                                    }),
                                    trackingArrowLeft: (0,helper_es/* getTrackingData */.O5)({
                                        isTrackContent: true,
                                        regionName: "productComboList",
                                        contentName: "btnChangeCombo",
                                        payload: JSON.stringify({
                                            comboTab: "Combo ".concat(activeTab.totalProductTab, " sản phẩm"),
                                            comboPromotion: comboGroup[activeTab.totalProductTab].combos[comboIndex].promotion.id,
                                            comboIndex: comboIndex + 1,
                                            target: "previous"
                                        })
                                    }),
                                    children: comboGroup[activeTab.totalProductTab].combos.map((combo, comboIndex)=>{
                                        const { promotion , conditions , totalAmount , totalDiscount , totalProduct , key ,  } = combo;
                                        const addComboToCart = async ()=>{
                                            const mainPayload = {
                                                override: true,
                                                groups: [
                                                    {
                                                        quantity: 1,
                                                        promotionId: promotion.id,
                                                        products: conditions.map((el, index)=>{
                                                            var ref, ref1;
                                                            return {
                                                                sku: el.product.sku,
                                                                promotionId: !!((ref = el.product.bestPromotionIds) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = el.product.bestPromotionIds) === null || ref1 === void 0 ? void 0 : ref1[0] : null,
                                                                quantity: el.requiredQuantity,
                                                                isPrimary: index === 0
                                                            };
                                                        })
                                                    }, 
                                                ]
                                            };
                                            await onAddComboItems(mainPayload, false);
                                        };
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboItem, {
                                                    combo: combo,
                                                    onClickProductChange: (selectedSku, conditionKey)=>{
                                                        setVisible(true);
                                                        setSelectingProduct({
                                                            sku: selectedSku,
                                                            conditionKey
                                                        });
                                                        setActiveCombo(combo);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                                    align: "center",
                                                    justify: "space-between",
                                                    borderTop: "1px solid divider",
                                                    marginTop: "s16",
                                                    padding: "s16",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                                            direction: "column",
                                                            gap: "s4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                                                    gap: "s8",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                                            level: 1,
                                                                            children: "".concat((0,i18n.t)("Tổng tiền"), ":")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                                                            color: "primary",
                                                                            level: 1,
                                                                            children: (0,number_es/* formatCurrency */.xG)(totalAmount, numberDisplayFormat)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                                                    gap: "s8",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                                            color: "primary",
                                                                            level: 1,
                                                                            children: "".concat((0,i18n.t)("Tiết kiệm"), ":")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                                            color: "primary",
                                                                            level: 1,
                                                                            children: (0,number_es/* formatCurrency */.xG)(totalDiscount, numberDisplayFormat)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, ComboCarousel_objectSpreadProps(ComboCarousel_objectSpread({
                                                                variant: "secondary",
                                                                onClick: addComboToCart
                                                            }, (0,helper_es/* getTrackingData */.O5)({
                                                                isTrackContent: true,
                                                                regionName: "productComboList",
                                                                contentName: "btnAddToCart",
                                                                payload: JSON.stringify({
                                                                    promotionType: "combo",
                                                                    comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                                                    comboPromotion: promotion.id,
                                                                    comboIndex: comboIndex + 1,
                                                                    skus: conditions.map((con)=>con.product.sku)
                                                                })
                                                            })), {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                                                    level: 2,
                                                                    color: "primary",
                                                                    children: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                                                                })
                                                            }))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(comboIndex).concat(key));
                                    })
                                }, visible ? 1 : 0)
                            })
                        ]
                    })
                ]
            }),
            visible && !!activeCombo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboSelectionModal, ComboCarousel_objectSpread({
                closeModal: (selectingCombo)=>{
                    setVisible(false);
                    setSelectingProduct(undefined);
                    // set active tab according to active combo
                    if (selectingCombo) {
                        const indexTab = Object.keys(comboGroup).findIndex((item)=>Number(item) === selectingCombo.totalProduct);
                        setActiveTab({
                            index: indexTab,
                            totalProductTab: selectingCombo.totalProduct
                        });
                        if (comboGroup && activeTab.totalProductTab) {
                            const activeGroup = comboGroup[activeTab.totalProductTab];
                            const selectedIndex = activeGroup.combos.findIndex((el)=>el.key === selectingCombo.key);
                            setComboIndex(selectedIndex);
                        }
                    }
                },
                selectingProduct: selectingProduct,
                visible: visible
            }, productComboHook))
        ]
    }) : null;
};
const ComboTabWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboCarousel_templateObject());
const GlideWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ComboCarousel_templateObject1());

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/DetailPage.tsx
function DetailPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DetailPage_templateObject() {
    const data = DetailPage_taggedTemplateLiteral([
        ""
    ]);
    DetailPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailPage_templateObject1() {
    const data = DetailPage_taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 24px;\n    color: #0000000f;\n  }\n"
    ]);
    DetailPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










































const ConfirmOver18YearOldModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(76698), __webpack_require__.e(23540), __webpack_require__.e(83822)]).then(__webpack_require__.bind(__webpack_require__, 923540)).then((mod)=>mod.ConfirmOver18YearOldModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(923540)
            ]
    }
});
const RelatedProducts = dynamic_default()(()=>__webpack_require__.e(/* import() */ 36313).then(__webpack_require__.bind(__webpack_require__, 136313)).then((mod)=>mod.RelatedProducts), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(136313)
            ]
    }
});
const SGCFrequentlyBoughtTogether = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(92952), __webpack_require__.e(45590), __webpack_require__.e(33421)]).then(__webpack_require__.bind(__webpack_require__, 926380)).then((mod)=>mod.SGCFrequentlyBoughtTogether), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(926380)
            ]
    }
});
const MAX_WIDTH = 1600;
const MAX_LINES_BEFORE_ELLIPSIS = 2;
const DetailPageSGC = (param)=>{
    let {} = param;
    var ref;
    const { epicOmni1428 , epicOmni1585 , epicOmni1550 , addSchemaBreadcrumbList , baseDomain ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { breadcrumbs , product , promotionBlocks , showPopupCheckAge , setShowPopupCheckAge , inlineBanners , relatedProducts ,  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const [actionButtonsRef, isVisibleActionButtons] = (0,useIntersectionObserver/* useIntersectionObserver */.S)();
    const [triggerFooterRef, isVisibleTriggerFooter] = (0,useIntersectionObserver/* useIntersectionObserver */.S)();
    const { asPath  } = (0,next_router.useRouter)();
    const showTierPromotionsBlock = !!epicOmni1428 || !!epicOmni1585;
    const isPromotionDefaultGroupType = (promotions, groupType)=>{
        return groupType ? groupType === v2/* PromotionGroupType.GROUP_TYPE_DEFAULT */.VM.GROUP_TYPE_DEFAULT : promotions.every((p)=>!p.isSelectable);
    };
    const newPromotionBlocks = (0,react.useMemo)(()=>{
        // create a promotion with groupType of GROUP_TYPE_TIER_PROMOTIONS
        const tierPromotionBlock = {
            title: "",
            groupType: v2/* PromotionGroupType.GROUP_TYPE_TIER_PROMOTIONS */.VM.GROUP_TYPE_TIER_PROMOTIONS,
            promotions: promotionBlocks.flatMap((p)=>p.promotions),
            description: ""
        };
        /**  because cart return promotions with groupType in order of Default --> Selectable --> Exclusive
     * we only need to check if default type available or not
     * if yes --> add tier promotions type after default type
     * if no --> add tier promotions to top of the list
     * we also check if there isn't any promotion in the list we return an empty array instead
     */ return !!promotionBlocks.length ? isPromotionDefaultGroupType(promotionBlocks[0].promotions, promotionBlocks[0].groupType) ? [
            promotionBlocks[0],
            tierPromotionBlock,
            ...promotionBlocks.slice(1, promotionBlocks.length), 
        ] : [
            tierPromotionBlock,
            ...promotionBlocks
        ] : [];
    }, [
        promotionBlocks
    ]);
    const mapTierPromotions = (promotions)=>{
        return promotions.map((promotion)=>{
            var ref;
            return {
                cartPromotionId: null,
                promotionId: promotion.promotionId,
                promotionCode: promotion.promotionCode,
                isSelectable: promotion.isSelectable,
                imageUrl: promotion.imageUrl,
                title: promotion.title,
                description: promotion.description,
                endedAt: ((ref = promotion.endedAt) === null || ref === void 0 ? void 0 : ref.toString()) || "",
                name: promotion.name || "",
                tierDescriptions: promotion.tierDescriptions,
                highlightedDescriptions: promotion.highlightedDescriptions,
                customerTierDescriptions: promotion.customerTierDescriptions
            };
        });
    };
    (0,react.useEffect)(()=>{
        if (product) {
            var ref, ref1, ref2, ref3;
            (0,common/* saveRecentlyProduct */.l3)(product.sku, search/* RECENTLY_VIEWED_PRODUCTS_KEY */._V);
            (0,product_es/* trackViewProductDetail */.g)({
                price: (ref = product.price) === null || ref === void 0 ? void 0 : ref.price,
                name: product.name,
                sku: product.sku,
                brand: (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name,
                category: ((ref2 = product.categories) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name) || "",
                sellerSku: product === null || product === void 0 ? void 0 : product.sellerSku
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        product === null || product === void 0 ? void 0 : product.sku
    ]);
    if (!product) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* NotFoundProductLayout */.DH, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoProductsFound_es/* NoProductsFound */.H, {
                show: true,
                text: (0,i18n.t)("Kh\xf4ng t\xecm thấy sản phẩm")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!addSchemaBreadcrumbList && !!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            itemListElement: breadcrumbs.map((param, index)=>{
                                let { name , link , isLast  } = param;
                                return {
                                    "@type": "ListItem",
                                    position: index + 1,
                                    item: {
                                        name: !index ? (0,i18n.t)("Trang chủ") : name,
                                        "@id": link === "#" || !!isLast ? "".concat(baseDomain).concat(asPath) : "".concat(baseDomain).concat(link)
                                    }
                                };
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaData/* MetaData */.U, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                fluid: true,
                maxWidth: MAX_WIDTH,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                            breadcrumbs: breadcrumbs || []
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailBlock, {
                            marginBottom: 24,
                            backgroundColor: "white",
                            padding: 2,
                            style: {
                                borderRadius: "1rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                                    width: "36.36%",
                                    marginRight: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                                        padding: "s8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImages, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                                align: "bottom",
                                                padding: [
                                                    "s0",
                                                    "s8"
                                                ],
                                                justify: "start",
                                                marginBottom: "s16",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtons/* ShareButtons */.n, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    fontSize: 13,
                                                                    lineHeight: "20px",
                                                                    fontWeight: 400
                                                                },
                                                                children: (0,i18n.t)("Y\xeau th\xedch")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistButton/* WishlistButton */.s, {
                                                                sku: product.sku,
                                                                size: "24"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBannerPlaceholder_es/* BannerInlinePlaceholder */.Q, {
                                                banners: inlineBanners,
                                                className: smartBanner/* INLINE_BANNER_CLASSNAME.INLINE_PDP_RELATEDPROMO */.h.INLINE_PDP_RELATEDPROMO
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductProviderInfo/* ProductProviderInfo */.S, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Policies/* Policies */.r, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                                    width: "61.67%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                                        padding: "s8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSalePromotionBlock/* FlashSalePromotionBlock */._, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo/* ProductInfo */.w, {
                                                product: product
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductUnitAndPrice/* ProductUnitAndPrice */.L, {}),
                                            (ref = !!showTierPromotionsBlock ? newPromotionBlocks : promotionBlocks) === null || ref === void 0 ? void 0 : ref.map((block, index)=>{
                                                const isDefaultGroup = isPromotionDefaultGroupType(block.promotions, block.groupType);
                                                return isDefaultGroup ? // If all `title` fields in the default promotions array of default group type are empty strings, we should hide this block */}
                                                block.promotions.every((promotion)=>!promotion.title) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultPromotions/* DefaultPromotions */.G, {
                                                    promotions: block.promotions
                                                }, index) : block.groupType === v2/* PromotionGroupType.GROUP_TYPE_TIER_PROMOTIONS */.VM.GROUP_TYPE_TIER_PROMOTIONS ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        epicOmni1585 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TierPromotion/* TierPromotions */.X, {
                                                            productPromotions: [
                                                                {
                                                                    title: "",
                                                                    groupType: undefined,
                                                                    promotions: mapTierPromotions(block.promotions)
                                                                }, 
                                                            ],
                                                            isCustomerTierPromotions: true
                                                        }),
                                                        epicOmni1428 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TierPromotion/* TierPromotions */.X, {
                                                            productPromotions: [
                                                                {
                                                                    title: "",
                                                                    groupType: undefined,
                                                                    promotions: mapTierPromotions(block.promotions)
                                                                }, 
                                                            ],
                                                            maxLinesBeforeEllipsis: MAX_LINES_BEFORE_ELLIPSIS
                                                        })
                                                    ]
                                                }) : null;
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityBlock_QuantityBlock, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButtons, {
                                                actionButtonsRef: actionButtonsRef
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRecipes, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPromotions, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentPromotion.PaymentPromotion, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboCarousel, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProducts, {
                            relatedProducts: relatedProducts
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SGCFrequentlyBoughtTogether, {}),
                        epicOmni1550 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSection.ReviewSection, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_ReviewSection.ReviewSection, {
                            product: product,
                            wrapperBorderRadius: "16px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kC, {
                            marginBottom: 16,
                            marginTop: 16,
                            alignItems: "stretch",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                                    width: "68.5%",
                                    marginRight: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProductDescription/* ProductDescription */.v, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                                    width: "30%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductNews/* ProductNews */.E, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentViewedProducts/* RecentViewedProducts */.Z, {
                            render: (products)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRecentProductCarousel, {
                                    recentProducts: products
                                }),
                            excludedSkus: [
                                product.sku
                            ]
                        })
                    ]
                })
            }),
            !isVisibleActionButtons && !isVisibleTriggerFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomButtons, {}),
            showPopupCheckAge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOver18YearOldModal, {
                showPopupCheckAge: showPopupCheckAge,
                setShowPopupCheckAge: setShowPopupCheckAge,
                okText: (0,i18n.t)("T\xf4i tr\xean 18 tuổi")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: triggerFooterRef
            })
        ]
    });
};
const DetailBlock = (0,emotion_styled_browser_esm["default"])(dist/* Flex */.kC)(DetailPage_templateObject());
const Divider = emotion_styled_browser_esm["default"].div(DetailPage_templateObject1());


/***/ }),

/***/ 893202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(670894);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  cursor: zoom-in;\n  border-width: 1;\n  border-color: rgba(0, 0, 0, 0.06);\n  border-style: solid;\n  border-radius: 8px;\n  aspect-ratio: 1;\n\n  &::after {\n    position: absolute;\n    top: 12px;\n    left: 12px;\n    font-size: 1.5rem;\n    color: #333;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject());
const ImageZoomStyled = (param)=>{
    let { image , width , height , onClick ,  } = param;
    const handleMouseOver = (e)=>{
        const wrapper = e.currentTarget;
        const scale = wrapper.getAttribute("data-scale") || "1";
        const img = wrapper.querySelector("div");
        if (img) img.style.transform = "scale(".concat(scale, ")");
    };
    const handleMouseOut = (e)=>{
        const img = e.currentTarget.querySelector("div");
        if (img) {
            img.style.transform = "scale(1)";
            img.style.transformOrigin = "";
        }
    };
    const handleMouseMove = (e)=>{
        const wrapper = e.currentTarget;
        const img = wrapper.querySelector("div");
        if (!img) return;
        const rect = wrapper.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width * 100;
        const y = (e.clientY - rect.top) / rect.height * 100;
        img.style.transformOrigin = "".concat(x, "% ").concat(y, "%");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageWrapper, {
        "data-scale": 2.0,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        onMouseMove: handleMouseMove,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, _objectSpreadProps(_objectSpread({
            contain: true
        }, image), {
            height: height,
            src: (image === null || image === void 0 ? void 0 : image.src) || "",
            onClick: onClick,
            imageWidth: width
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageZoomStyled);


/***/ }),

/***/ 434883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNDAgNDAiPgogIDwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyOS4zLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiAyLjEuMCBCdWlsZCAxNTEpICAtLT4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLnN0MCB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQoKICAgICAgLnN0MSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIyMCIgeTE9IjMuNDMiIHgyPSIyMCIgeTI9IjM2LjcyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzExYTNlYyIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyZDc1ZWUiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMCwxLjc2QzguOTUsMS43NiwwLDkuOTMsMCwyMGMwLDMuNzUsMS4yNCw3LjIzLDMuMzYsMTAuMTIuMTMuMTcuMTQuNC4wNC41OGwtMi4yMyw0LjEzYy0uMjMuNDIuMTcuOTEuNjMuNzhsNS4xNy0xLjVjLjE2LS4wNS4zNC0uMDEuNDcuMDksMy40MywyLjUzLDcuOCw0LjA0LDEyLjU1LDQuMDQsMTEuMDUsMCwyMC04LjE3LDIwLTE4LjI0UzMxLjA1LDEuNzYsMjAsMS43NloiLz4KICA8Zz4KICAgIDxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik03Ljc0LDIzLjM1YzEuNTYsMCwzLjAyLDAsNC40OCwwLC44MiwwLDEuMjYuMzYsMS4zNCwxLC4xLjgyLS4zOCwxLjM2LTEuMjcsMS4zNy0xLjY3LjAyLTMuMzQsMC01LjAxLDAtLjQ4LDAtLjk3LjAyLTEuNDUtLjAxLS42LS4wMy0xLjE5LS4xNS0xLjQ3LS43Ny0uMjktLjYyLS4wOS0xLjE4LjMxLTEuNjgsMS42LTIuMDMsMy4xOS00LjA2LDQuNzktNi4wOS4wOS0uMTIuMTktLjI0LjI4LS4zNi0uMS0uMTgtLjI1LS4xLS4zNy0uMS0xLjEyLDAtMi4yNCwwLTMuMzYsMC0uMjYsMC0uNTItLjAyLS43Ny0uMDktLjUyLS4xNC0uODMtLjU1LS44NC0xLjA1LDAtLjUuMy0uOTIuODItMS4wNi4yNC0uMDcuNTEtLjA5Ljc2LS4wOSwxLjg0LDAsMy42OCwwLDUuNTMsMCwuMzMsMCwuNjUsMCwuOTcuMTIuNy4yNCwxLjAxLjg4LjcyLDEuNTctLjI1LjU5LS42NCwxLjEtMS4wMywxLjYtMS4zNSwxLjcyLTIuNzEsMy40My00LjA2LDUuMTUtLjExLjEzLS4yMS4yNy0uMzguNDlaIi8+CiAgICA8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjUuOTgsMTkuN2MwLDEuNiwwLDMuMiwwLDQuOCwwLC45Mi0uODEsMS41My0xLjY4LDEuMzItLjUyLS4xMy0uOTEtLjY5LS45MS0xLjMzLDAtMi43NCwwLTUuNDcsMC04LjIxLDAtLjQ4LDAtLjk2LDAtMS40NS4wMS0uNzkuNTItMS4zMSwxLjI4LTEuMzIuNzgsMCwxLjMxLjUxLDEuMzIsMS4zMywwLDEuNjIsMCwzLjI0LDAsNC44NVoiLz4KICAgIDxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yMi4yNCwxOC40Yy0uMDEtLjgzLS43OC0xLjM1LTEuNTktMS4xOS0uNDMuMDktLjY4LjM4LS45My43LTEuMjktMS4xMy0yLjcxLTEuMTktNC4xMi0uMzctMS42OS45OS0yLjMyLDIuNjEtMi4xLDQuNS4yLDEuNzYuOTYsMy4xOSwyLjgsMy43OSwxLjE1LjM3LDIuMjEuMjQsMy4xNS0uNTIuMjQtLjIuMzItLjE2LjQ5LjA2LjM2LjQ1LjkxLjU4LDEuNDQuNC41MS0uMTcuODYtLjYxLjg2LTEuMTcuMDEtMi4wNy4wMi00LjEzLDAtNi4yWk0xOS4yMSwyMi45NGMtLjY3LjktMi4wNC45LTIuNzEsMC0uMzEtLjQxLS40Mi0uODktLjQzLTEuMjUtLjAxLTEuNDYuNzgtMi4zNCwxLjkxLTIuMjcuNTEuMDMuOTIuMjUsMS4yMy42Ni41OC43OC41OCwyLjA4LDAsMi44NloiLz4KICAgIDxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0zNS42NiwyMS4zYy0uMDgtMi41OC0yLjAxLTQuMzUtNC42NC00LjI3LTIuNDguMDgtNC4yMiwyLjA2LTQuMTQsNC43MS0uMDQsMi41OCwyLjEsNC41Myw0Ljc4LDQuMjcsMi40Ny0uMjUsNC4wNy0yLjEsMy45OS00LjcxWk0zMi42LDIyLjk3Yy0uNjcuODctMi4wMi44Ni0yLjY4LS4wMi0uMzItLjQzLS40NC0uOTItLjQ0LTEuNDUsMC0xLjI4Ljc4LTIuMTQsMS45LTIuMDguNTEuMDMuOTIuMjQsMS4yMy42NS41OS43OS41OSwyLjEyLS4wMSwyLjlaIi8+CiAgPC9nPgo8L3N2Zz4=");

/***/ })

}]);